import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends Record<string, unknown>> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends Record<string, unknown>, K extends keyof T> = Partial<
  Record<K, never>
>;
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  AvailabilityScalar: { input: Availability; output: Availability };
}

export enum AdHeaderConfigScriptPageName {
  BookingConfirmation = 'booking_confirmation',
  Collections = 'collections',
  CurrentSales = 'current_sales',
  Sale = 'sale',
  Search = 'search',
}

export interface AdHeaderConfigScriptResponse {
  __typename?: 'AdHeaderConfigScriptResponse';
  /** Code snippet to insert */
  script?: Maybe<Scalars['String']['output']>;
}

export interface Address {
  __typename?: 'Address';
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  line3?: Maybe<Scalars['String']['output']>;
  line4?: Maybe<Scalars['String']['output']>;
  line5?: Maybe<Scalars['String']['output']>;
}

export interface Advertisement {
  __typename?: 'Advertisement';
  /** Concatenation of page and info about place where ad should be placed */
  placementKey?: Maybe<Scalars['String']['output']>;
  /** Code snippet to insert */
  script?: Maybe<Scalars['String']['output']>;
}

export interface AirportFacet {
  __typename?: 'AirportFacet';
  /** The amount */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Pre-formatted amount for display */
  amountForDisplay?: Maybe<Scalars['String']['output']>;
  /** Airport city name */
  cityName?: Maybe<Scalars['String']['output']>;
  /** Airport code */
  code?: Maybe<Scalars['String']['output']>;
  /** Airport name */
  name?: Maybe<Scalars['String']['output']>;
}

export interface AirportInfo {
  __typename?: 'AirportInfo';
  /** Airport city name */
  cityName?: Maybe<Scalars['String']['output']>;
  /** Airport code */
  code?: Maybe<Scalars['String']['output']>;
  /** Airport name */
  name?: Maybe<Scalars['String']['output']>;
}

export interface Availability {
  __typename?: 'Availability';
  /** The calendar entries */
  calendar?: Maybe<Maybe<CalendarAvailability>[]>;
  /** The first available check in date */
  firstAvailableCheckInDate?: Maybe<Scalars['String']['output']>;
  /** The last available check in date */
  lastAvailableCheckInDate?: Maybe<Scalars['String']['output']>;
  /** Query operation name */
  operationName?: Maybe<Scalars['String']['output']>;
  /** The basis of the package price */
  packagePriceBasis?: Maybe<PackagePriceBasis>;
  /** Tracy signed booking id */
  signedBookingId?: Maybe<Scalars['String']['output']>;
  /** Type of the stay */
  stayType?: Maybe<Scalars['String']['output']>;
}

export interface AvailabilityAmount {
  __typename?: 'AvailabilityAmount';
  /** The amount */
  amount: Scalars['Float']['output'];
  /** The amount to display in FE */
  amountForDisplay: Scalars['String']['output'];
}

export interface AvailabilityCheckOutDate {
  __typename?: 'AvailabilityCheckOutDate';
  /** The available rooms */
  availableRooms: Scalars['Int']['output'];
  /** The check out date as string */
  date: Scalars['String']['output'];
  /** The price for check out date */
  price?: Maybe<AvailabilityPrice>;
}

export interface AvailabilityPrice {
  __typename?: 'AvailabilityPrice';
  /** The final rate */
  finalRate: AvailabilityAmount;
  /** The local fees */
  localFees: AvailabilityAmount;
  /** The price */
  price: AvailabilityAmount;
  /** The room rate */
  roomRate: AvailabilityAmount;
  /** The taxes */
  taxes: AvailabilityAmount;
}

export interface AvailabilityPrices {
  __typename?: 'AvailabilityPrices';
  /** Checkin date */
  checkin?: Maybe<Scalars['String']['output']>;
  /** Checkout date */
  checkout?: Maybe<Scalars['String']['output']>;
  /** Offer id */
  offer?: Maybe<Scalars['String']['output']>;
  /** Price per night for display purposes (£123) */
  pricePerNightForDisplay?: Maybe<Scalars['String']['output']>;
  /**
   * Label for the price per night (e.g. 'per night per room')
   * @deprecated Necessary labels have been constructed by KingFisher
   */
  pricePerNightLabel?: Maybe<Scalars['String']['output']>;
  /** Price per person for display (e.g £1,800) */
  pricePerPersonForDisplay?: Maybe<Scalars['String']['output']>;
  /**
   * Label for the price per person (e.g `per person`)
   * @deprecated Necessary labels have been constructed by KingFisher
   */
  pricePerPersonLabel?: Maybe<Scalars['String']['output']>;
  /** Primary price value for display purposes */
  priceValueForDisplay?: Maybe<Scalars['String']['output']>;
  /** A hint for the primary price value */
  priceValueHint?: Maybe<Scalars['String']['output']>;
  /** Prefix label of the primary price value */
  priceValuePrefixLabel?: Maybe<Scalars['String']['output']>;
  /** Suffix label of the primary price value */
  priceValueSuffixLabel?: Maybe<Scalars['String']['output']>;
  /** Total price for display purposes (£1234) */
  totalPriceForDisplay?: Maybe<Scalars['String']['output']>;
  /**
   * Label for the total price (e.g. 'total')
   * @deprecated Necessary labels have been constructed by KingFisher
   */
  totalPriceLabel?: Maybe<Scalars['String']['output']>;
  /**
   * Total price for date search for display packages (e.g £1,000 total, based on 2 people)
   * @deprecated Necessary labels have been constructed by KingFisher
   */
  totalPriceLabelForDateSearch?: Maybe<Scalars['String']['output']>;
  /**
   * Total price for no date search for display packages (e.g £1,000 total, 2 people, 7 nights)
   * @deprecated Necessary labels have been constructed by KingFisher
   */
  totalPriceLabelForNoDateSearch?: Maybe<Scalars['String']['output']>;
  /**
   * Sub-label for the total price (e.g. 'based on 2 people')
   * @deprecated Necessary labels have been constructed by KingFisher
   */
  totalPriceSubLabel?: Maybe<Scalars['String']['output']>;
  /** Total rack rate for display purposes (£1560) */
  totalRackRateForDisplay?: Maybe<Scalars['String']['output']>;
}

export interface AvailableCheckInDate {
  __typename?: 'AvailableCheckInDate';
  /** The amount */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Pre-formatted amount for display */
  amountForDisplay?: Maybe<Scalars['String']['output']>;
  /** The check out dates for the check in date */
  checkOutDates: AvailableCheckOutDate[];
  /** The check in date as string */
  date: Scalars['String']['output'];
  /** Whether the dates are refundable or not */
  isRefundable?: Maybe<Scalars['Boolean']['output']>;
}

export interface AvailableCheckOutDate {
  __typename?: 'AvailableCheckOutDate';
  /** The amount */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Pre-formatted amount for display */
  amountForDisplay?: Maybe<Scalars['String']['output']>;
  /** The check out date as string */
  date: Scalars['String']['output'];
  /** The number of nights */
  nights?: Maybe<Scalars['Int']['output']>;
}

export interface Badge {
  __typename?: 'Badge';
  /** Background color of the badge, eg #FEFEFE, supports light and dark mode */
  backgroundColor?: Maybe<BadgeColorScheme>;
  /** Where badge should be rendered, some are marketing only badges, some site only */
  channel: BadgeChannel;
  /** DEPRECATED DEV-66033 by font, icon and background color. The color of the Badge */
  color?: Maybe<Scalars['String']['output']>;
  /** Font color of the badge, eg #000000 supports light and dark mode */
  fontColor?: Maybe<BadgeColorScheme>;
  /** DEPRECATED DEV-66033 by priority. The flag saying if the Badge has high priority */
  highPriority?: Maybe<Scalars['Boolean']['output']>;
  /** Icon color(tint) used at badge, eg #000000, supports light and dark mode */
  iconColor?: Maybe<BadgeColorScheme>;
  /** The icon name of the Badge */
  iconName?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the Badge */
  name: Scalars['String']['output'];
  /** Importance of badge. Range 1 - 1000. Smaller number means greater importance. */
  priority: Scalars['Int']['output'];
  /** Tag used to filter out badges in some email templates */
  tag?: Maybe<Scalars['String']['output']>;
  /** The title of the Badge */
  title?: Maybe<Scalars['String']['output']>;
  /** The tooltip of the Badge */
  tooltip?: Maybe<BadgeTooltip>;
  /** Type - defines purpose of the badge and affects where it should be rendered */
  type: BadgeType;
}

export enum BadgeChannel {
  All = 'ALL',
  Email = 'EMAIL',
  Web = 'WEB',
}

export interface BadgeColorScheme {
  __typename?: 'BadgeColorScheme';
  dark: Scalars['String']['output'];
  light: Scalars['String']['output'];
}

export interface BadgeTooltip {
  __typename?: 'BadgeTooltip';
  /** The description of the Badge's Tooltip */
  description?: Maybe<Scalars['String']['output']>;
  /** The title of the Badge's Tooltip */
  title?: Maybe<Scalars['String']['output']>;
}

export enum BadgeType {
  Informational = 'INFORMATIONAL',
  Promotional = 'PROMOTIONAL',
}

export interface Booking {
  __typename?: 'Booking';
  /** Amended dates */
  amendedDates?: Maybe<Dates>;
  /** Booking dates */
  bookingDates: Dates;
  /** Booking fee amount */
  bookingFee?: Maybe<Price>;
  /** Cancellation info for a sale */
  cancellationInfo?: Maybe<CancellationInfo>;
  /** Cancellation policy for a booking */
  cancellationPolicy?: Maybe<BookingCancellationPolicy>;
  /** Cancellation Summaries available, if is cancellable */
  cancellationSummaries?: Maybe<Maybe<CancellationSummary>[]>;
  /** Number of nights booked */
  duration: Scalars['Int']['output'];
  /** check if booking has flights */
  hasFlights?: Maybe<Scalars['Boolean']['output']>;
  /** Hotel details */
  hotelDetails: HotelDetails;
  /** ID of the Booking */
  id: Scalars['String']['output'];
  /** Lead image of a sale */
  leadImage?: Maybe<Photo>;
  /** Links for booking */
  links: BookingLinks;
  /** Occupancy */
  occupancy?: Maybe<Occupancy>;
  /** Offer ID */
  offerId?: Maybe<Scalars['String']['output']>;
  /** What the customer paid */
  paidBreakdown?: Maybe<PriceBreakdown>;
  /** Amount paid by user that can be reused for rebooking */
  reusableAmountPaid?: Maybe<Price>;
  /** Number of rooms booked */
  rooms: Scalars['Int']['output'];
  /** Sale ID */
  saleId?: Maybe<Scalars['String']['output']>;
  /** Location of the sale */
  saleLocation: Location;
  /** Should allow resending confirmation email */
  shouldAllowResendEmails?: Maybe<Scalars['Boolean']['output']>;
  /** signed id for travelbird queries */
  signedId?: Maybe<Scalars['String']['output']>;
  /** Status of the booking */
  status: BookingStatus;
  /** Title of the sale booked */
  title: Scalars['String']['output'];
  /** token for travelbird queries */
  token?: Maybe<Scalars['String']['output']>;
  /** Total booking amount */
  totalBookingAmount?: Maybe<Price>;
  /** Transaction id of the Booking */
  transactionId: Scalars['String']['output'];
}

export interface BookingCancellationPolicy {
  __typename?: 'BookingCancellationPolicy';
  /** whether the reservation can be cancelled or not */
  isCancellable: Scalars['Boolean']['output'];
  /** whether the reservation can be rebooked or not */
  isRebookable: Scalars['Boolean']['output'];
  /** The reason why the reservation is not cancellable */
  notCancellableReason?: Maybe<Scalars['String']['output']>;
  /** Properties related to CancellationPolicy */
  properties?: Maybe<Maybe<CancellationPolicyProperty>[]>;
}

export interface BookingCancellationResponse {
  __typename?: 'BookingCancellationResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
}

export interface BookingLinks {
  __typename?: 'BookingLinks';
  /** Link to print pdf ATOL Certificate in english */
  printAtolFlightCertificateInEnglish?: Maybe<Scalars['String']['output']>;
  /** Link to print pdf ATOL Certificate in original language */
  printAtolFlightCertificateInOriginalLanguage?: Maybe<Scalars['String']['output']>;
  /** link to print confirmation email */
  printConfirmationEmail?: Maybe<Scalars['String']['output']>;
  /** Link to print pdf invoice */
  printPdfInvoice?: Maybe<Scalars['String']['output']>;
  /** Link to print pdf receipt */
  printPdfReceipt?: Maybe<Scalars['String']['output']>;
  /** Link to external booking details */
  viewExternalBookingDetails?: Maybe<Scalars['String']['output']>;
}

export interface BookingStats {
  __typename?: 'BookingStats';
  /** Visitors looking at the sale */
  currentVisitors?: Maybe<Scalars['Int']['output']>;
  /** Times booked already */
  timesBooked?: Maybe<Scalars['Int']['output']>;
}

export enum BookingStatus {
  Cancelled = 'CANCELLED',
  Past = 'PAST',
  Upcoming = 'UPCOMING',
}

export interface BookingsCount {
  __typename?: 'BookingsCount';
  cancelled: Scalars['Int']['output'];
  past: Scalars['Int']['output'];
  upcoming: Scalars['Int']['output'];
}

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
}

export interface Calendar {
  __typename?: 'Calendar';
  /** The available dates for booking */
  calendarEntries?: Maybe<Maybe<CalendarEntry>[]>;
  /** The currency for the displayed amounts */
  currency: Currency;
  /** The type of stay */
  stayType: StayType;
}

export interface CalendarAvailability {
  __typename?: 'CalendarAvailability';
  /** The cancellation selection information */
  cancellationSelectionInformation?: Maybe<Scalars['String']['output']>;
  /** The check in date as string */
  checkInDate: Scalars['String']['output'];
  /** The available check out dates for booking */
  checkOutDates?: Maybe<Maybe<AvailabilityCheckOutDate>[]>;
  /** The currency for the displayed amounts */
  currency: Scalars['String']['output'];
  /** Whether the dates are refundable or not */
  isRefundable?: Maybe<Scalars['Boolean']['output']>;
  /** The price for check in date */
  price?: Maybe<AvailabilityPrice>;
  /** The information regarding the rates including fees */
  showFeeInclusiveRates?: Maybe<Scalars['Boolean']['output']>;
  /** The information regarding the rates including taxes */
  showTaxInclusiveRates?: Maybe<Scalars['Boolean']['output']>;
}

export interface CalendarEntry {
  __typename?: 'CalendarEntry';
  /** Available for checkout only */
  checkOutDayOnly: Scalars['Boolean']['output'];
  /** Closed to arrival (CTA) */
  closedToArrival: Scalars['Boolean']['output'];
  /** Closed to departure (CTD) */
  closedToDeparture: Scalars['Boolean']['output'];
  /** The date of stay */
  date: Scalars['String']['output'];
  /** The maximum number of nights a user can select */
  maxLengthOfStay: Scalars['Int']['output'];
  /** The minimum number of nights a user can select */
  minLengthOfStay: Scalars['Int']['output'];
  /** Rate Code */
  rateCode: Scalars['String']['output'];
  /** The available prices */
  rates: CalendarRates;
}

export interface CalendarFacets {
  __typename?: 'CalendarFacets';
  /** The airport facets */
  airports?: Maybe<AirportFacet[]>;
  /** The night facets */
  nights?: Maybe<NightFacet[]>;
  /** The offer facets */
  offers?: Maybe<OfferFacet[]>;
  /** The basis of the package */
  packagePriceBasis?: Maybe<PackagePriceBasis>;
  /** The package type facets */
  packageTypes?: Maybe<PackageTypeFacet[]>;
}

export interface CalendarRates {
  __typename?: 'CalendarRates';
  rate: Price;
}

export interface CalendarSelectionSummary {
  __typename?: 'CalendarSelectionSummary';
  alreadyPaidBreakdown?: Maybe<PriceBreakdown>;
  balance: Price;
  cancellationSelectionInformation?: Maybe<Scalars['String']['output']>;
  priceBreakdown?: Maybe<PriceBreakdown>;
  rateCodes?: Maybe<Maybe<Scalars['String']['output']>[]>;
  resortFeeDisclaimer?: Maybe<Scalars['String']['output']>;
}

export interface CancellationEditorial {
  __typename?: 'CancellationEditorial';
  /** Confirmation Disclaimer to be shown before the user confirms the cancellation */
  confirmationDisclaimer: Scalars['String']['output'];
  /** The disclaimer */
  disclaimer: Scalars['String']['output'];
  /** The text of the button */
  mainCTA: Scalars['String']['output'];
  /** Description of the refund */
  refundTotalDescription?: Maybe<Scalars['String']['output']>;
  /** The cancellation summary subtitle */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** The cancellation summary title */
  title?: Maybe<Scalars['String']['output']>;
}

export interface CancellationInfo {
  __typename?: 'CancellationInfo';
  /** confirmation information */
  confirmationInformation?: Maybe<Scalars['String']['output']>;
  /** Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Description warning */
  descriptionWarning?: Maybe<Scalars['String']['output']>;
  /** Description warning with flights */
  descriptionWarningWithFlights?: Maybe<Scalars['String']['output']>;
  /** Description used for H+ */
  descriptionWithFlights?: Maybe<Scalars['String']['output']>;
  /** isRefundable */
  isRefundable: Scalars['Boolean']['output'];
  /** number of days for refundable policies */
  numberOfDays?: Maybe<Scalars['Int']['output']>;
  /** Summary */
  summary?: Maybe<Scalars['String']['output']>;
}

export enum CancellationPolicyKey {
  Deadline = 'DEADLINE',
  Refundable = 'REFUNDABLE',
}

export interface CancellationPolicyProperty {
  __typename?: 'CancellationPolicyProperty';
  key?: Maybe<CancellationPolicyKey>;
  value?: Maybe<Scalars['String']['output']>;
}

export interface CancellationSummary {
  __typename?: 'CancellationSummary';
  /** The refund method code */
  code: Scalars['String']['output'];
  /** Main copy to be displayed on the page */
  editorial: CancellationEditorial;
  /** What the customer will get refunded */
  toBeRefundedBreakdown: PriceBreakdown;
}

export interface CheapestPackage {
  __typename?: 'CheapestPackage';
  /** A photo of the cheapest package */
  photo?: Maybe<Photo>;
  /** The cheapest package's per-person lead rate */
  price?: Maybe<Price>;
}

export interface CheckIfUserRequiresPasswordResponse {
  __typename?: 'CheckIfUserRequiresPasswordResponse';
  requiresPassword?: Maybe<Scalars['Boolean']['output']>;
  userExists?: Maybe<Scalars['Boolean']['output']>;
}

export interface Collection {
  __typename?: 'Collection';
  description?: Maybe<Scalars['String']['output']>;
  /** Absolute URL for collection hero image */
  heroUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Absolute URL for collection hero image, with a template to replace with actual height and width
   * @deprecated We have internal image service now, use `heroUrl` instead and apply size to the image url by adding `h` and `w` params
   */
  heroUrlWithSize?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaKeywords?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
  tileImage?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
}

export interface CollectionPanel {
  __typename?: 'CollectionPanel';
  /** Absolute URL for collection cover image */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Absolute URL for collection cover image, with a template to replace with actual height and width
   * @deprecated We have internal image service now, use `imageUrl` instead and apply size to the image url by adding `h` and `w` params
   */
  imageUrlWithSize?: Maybe<Scalars['String']['output']>;
  /** Integer representing the display oder of the collection in the panel */
  position?: Maybe<Scalars['Int']['output']>;
  /** Localised display text for the collection */
  text?: Maybe<Scalars['String']['output']>;
  /** URL for page on site the collection panel links to */
  url?: Maybe<Scalars['String']['output']>;
}

export enum CollectionType {
  CuratedCollections = 'curatedCollections',
  TopDestinations = 'topDestinations',
  TripTypes = 'tripTypes',
}

export interface ConfirmationEmailResponse {
  __typename?: 'ConfirmationEmailResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
}

export interface ConsentHistoryEntry {
  actionSource?: InputMaybe<Scalars['String']['input']>;
  consentVal?: InputMaybe<Scalars['Boolean']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  option?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
}

export interface ConsumerInformation {
  __typename?: 'ConsumerInformation';
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ProductLineType>;
}

export enum CountdownVariant {
  None = 'NONE',
  NonUrgent = 'NON_URGENT',
  Urgent = 'URGENT',
}

export interface Credit {
  __typename?: 'Credit';
  /** Amount of the credit */
  amount?: Maybe<Price>;
  /** Currency of the credit */
  currency?: Maybe<Scalars['String']['output']>;
  /** Date the credit was issued to user */
  dateIssued?: Maybe<Scalars['String']['output']>;
  /** Date the credit was used */
  dateRedeemed?: Maybe<Scalars['String']['output']>;
  /** Description of the credit */
  description?: Maybe<Scalars['String']['output']>;
  /** Date the credit expires */
  expiresOn?: Maybe<Scalars['String']['output']>;
  /** Minimum Booking Amount of the credit */
  minimumBookingAmount?: Maybe<Price>;
  /** Status of the credit */
  status?: Maybe<CreditStatus>;
}

export enum CreditStatus {
  Active = 'ACTIVE',
  RefundedCash = 'REFUNDED_CASH',
  Used = 'USED',
}

export interface CreditSummary {
  __typename?: 'CreditSummary';
  /** List of users credits */
  credits?: Maybe<Maybe<Credit>[]>;
  /** Sum of all users credits */
  sumOfAllCredits?: Maybe<Price>;
  /** Sum of all users available credits */
  sumOfAvailableCredits?: Maybe<Price>;
  /** Sum of all users used credits */
  sumOfUsedCredits?: Maybe<Price>;
}

export interface Currency {
  __typename?: 'Currency';
  /** Currency code */
  currencyCode?: Maybe<Scalars['String']['output']>;
}

export interface Dates {
  __typename?: 'Dates';
  /** End date */
  end?: Maybe<Scalars['String']['output']>;
  /** Start date */
  start?: Maybe<Scalars['String']['output']>;
}

export interface DisplayFacets {
  __typename?: 'DisplayFacets';
  facilities?: Maybe<Maybe<DisplayFacilityGroupEntry>[]>;
  hotelFacilities?: Maybe<Maybe<DisplayFacilityGroupEntry>[]>;
  isOccupancyMismatch?: Maybe<Scalars['Boolean']['output']>;
  packageFacilities?: Maybe<Maybe<DisplayFacilityGroupEntry>[]>;
}

export interface DisplayFacility {
  __typename?: 'DisplayFacility';
  /** Key of single facility, called also honeycomb fact , eg: kids_club, tennis_court. What is sent in refinement facets matches strings provided in key attribute here */
  key: Scalars['String']['output'];
  /** Translation of the facility */
  name: Scalars['String']['output'];
}

export interface DisplayFacilityGroupEntry {
  __typename?: 'DisplayFacilityGroupEntry';
  /** Fact group name, also known as facility group, eg Leisure activities */
  groupName: Scalars['String']['output'];
  /** Facts belonging to the group. Various groups can contain same fact */
  values?: Maybe<Maybe<DisplayFacility>[]>;
}

export interface FacilitiesAttribute {
  __typename?: 'FacilitiesAttribute';
  key: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Maybe<FacilitiesAttributeValue>[]>;
}

export interface FacilitiesAttributeValue {
  __typename?: 'FacilitiesAttributeValue';
  end?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
}

export interface FacilitiesFact {
  __typename?: 'FacilitiesFact';
  attributes?: Maybe<Maybe<FacilitiesAttribute>[]>;
  exists?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  level?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  units?: Maybe<Maybe<FacilitiesUnit>[]>;
}

export interface FacilitiesGroup {
  __typename?: 'FacilitiesGroup';
  facts?: Maybe<Maybe<FacilitiesFact>[]>;
  key: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface FacilitiesUnit {
  __typename?: 'FacilitiesUnit';
  key: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface FavoriteResponse {
  __typename?: 'FavoriteResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
}

export enum FeatureFlagTypes {
  AbTest = 'AB_TEST',
  FeatureFlag = 'FEATURE_FLAG',
  KillSwitch = 'KILL_SWITCH',
  RollOut = 'ROLL_OUT',
}

export interface FeatureFlags {
  __typename?: 'FeatureFlags';
  /** Active state of feature for user identified by key */
  activeKey: Scalars['String']['output'];
  /** Bucket size for the feature key which is active for the user */
  activeSplit: Scalars['Int']['output'];
  /** The control key setup for the feature */
  controlKey?: Maybe<Scalars['String']['output']>;
  /** When this feature was last updated */
  lastUpdated: Scalars['String']['output'];
  /** What is the type of this flag  */
  type: FeatureFlagTypes;
  /** Unique identifier for this flag */
  uniqueId?: Maybe<Scalars['String']['output']>;
}

export interface FlightPreferencesInput {
  /** Airport departure code */
  departureAirport?: InputMaybe<Scalars['String']['input']>;
  /** Number of durations */
  duration?: InputMaybe<Scalars['Int']['input']>;
  /** People per room */
  groups?: InputMaybe<InputMaybe<GroupsInput>[]>;
  /** People with age */
  people?: InputMaybe<InputMaybe<PersonInput>[]>;
}

export interface FlightPrices {
  __typename?: 'FlightPrices';
  /** All departure airports */
  airports?: Maybe<Maybe<HotelPlusAirports>[]>;
  /** Departure airport code for price */
  departureAirportCode?: Maybe<Scalars['String']['output']>;
  /** Departure airport name for price */
  departureAirportName?: Maybe<Scalars['String']['output']>;
  /** duration for price */
  duration?: Maybe<Scalars['Int']['output']>;
  /** All durations */
  durations?: Maybe<Maybe<HotelPlusDurations>[]>;
  /** All offers */
  offers?: Maybe<Maybe<HotelPlusOffers>[]>;
  /** The basis of the package price */
  packagePriceBasis?: Maybe<PackagePriceBasis>;
  /** Price for an offer */
  priceForDisplay?: Maybe<Scalars['String']['output']>;
}

export interface FrequentlyAskedQuestion {
  __typename?: 'FrequentlyAskedQuestion';
  answer: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  question: Scalars['String']['output'];
}

export interface FrequentlyAskedSection {
  __typename?: 'FrequentlyAskedSection';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  questions?: Maybe<Maybe<FrequentlyAskedQuestion>[]>;
  subSections?: Maybe<Maybe<FrequentlyAskedSubSection>[]>;
}

export interface FrequentlyAskedSubSection {
  __typename?: 'FrequentlyAskedSubSection';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  questions: FrequentlyAskedQuestion[];
}

/** Gladly user identity, for use in a client-side Gladly.setUser() call. Null fields are omitted rather than absent for anonymous users — see Query.gladlyIdentity. */
export interface GladlyIdentity {
  __typename?: 'GladlyIdentity';
  /** The user's email — present for a semi-authenticated user, or as a fallback when no JWT is available. */
  email?: Maybe<Scalars['String']['output']>;
  /** A trusted JWT identifying a fully authenticated user. Falls back to email/name if unobtainable. */
  jwt?: Maybe<Scalars['String']['output']>;
  /** The user's display name, if available. */
  name?: Maybe<Scalars['String']['output']>;
}

export interface GroupsInput {
  /** People per room */
  people?: InputMaybe<InputMaybe<Scalars['Int']['input']>[]>;
}

export interface HomepagePromotionalSection {
  __typename?: 'HomepagePromotionalSection';
  altTextDesktop?: Maybe<Scalars['String']['output']>;
  altTextMobile?: Maybe<Scalars['String']['output']>;
  callToActionRedirectLink?: Maybe<Scalars['String']['output']>;
  callToActionText?: Maybe<Scalars['String']['output']>;
  contentDescription?: Maybe<Scalars['String']['output']>;
  contentTitle?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<PromotionalContentType>;
  defaultEntry?: Maybe<Scalars['Boolean']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  imagePathDesktop?: Maybe<Scalars['String']['output']>;
  imagePathMobile?: Maybe<Scalars['String']['output']>;
  internalContentName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
}

export interface HotelDetails {
  __typename?: 'HotelDetails';
  /** Address of the hotel */
  address?: Maybe<Address>;
  /** customerSupport email */
  customerSupportEmail?: Maybe<Scalars['String']['output']>;
  /** customerSupport number */
  customerSupportNumber?: Maybe<Scalars['String']['output']>;
}

export interface HotelPlusAirports {
  __typename?: 'HotelPlusAirports';
  /** Departure airport city name */
  departureAirportCityName?: Maybe<Scalars['String']['output']>;
  /** Departure airport code */
  departureAirportCode?: Maybe<Scalars['String']['output']>;
  /** Departure airport name */
  departureAirportName?: Maybe<Scalars['String']['output']>;
  /** Airport price */
  price?: Maybe<Scalars['Float']['output']>;
  /** Airport price for display */
  priceForDisplay?: Maybe<Scalars['String']['output']>;
}

export interface HotelPlusDurations {
  __typename?: 'HotelPlusDurations';
  /** Number of durations */
  duration?: Maybe<Scalars['Int']['output']>;
  /** Duration price */
  price?: Maybe<Scalars['Float']['output']>;
  /** Duration price for display */
  priceForDisplay?: Maybe<Scalars['String']['output']>;
}

export interface HotelPlusOffers {
  __typename?: 'HotelPlusOffers';
  /** External reference */
  externalReference?: Maybe<Scalars['String']['output']>;
  /** Offer Name */
  name?: Maybe<Scalars['String']['output']>;
  /** Offer id */
  offerId?: Maybe<Scalars['String']['output']>;
  /** Offer price */
  price?: Maybe<Scalars['Float']['output']>;
  /** Offer price for display */
  priceForDisplay?: Maybe<Scalars['String']['output']>;
}

export enum IconName {
  Anchor = 'anchor',
  Apple = 'apple',
  Arrow = 'arrow',
  Arrowdown = 'arrowdown',
  Arrowright = 'arrowright',
  Asterisk = 'asterisk',
  Bell = 'bell',
  Bolt = 'bolt',
  Book = 'book',
  Bookmark = 'bookmark',
  Calendar = 'calendar',
  Camera = 'camera',
  Caret = 'caret',
  Certificate = 'certificate',
  Checkmark = 'checkmark',
  Close = 'close',
  Creditcard = 'creditcard',
  Deposit = 'deposit',
  Desktop = 'desktop',
  Dollar = 'dollar',
  Earth = 'earth',
  Euro = 'euro',
  Facebook = 'facebook',
  Film = 'film',
  Flag = 'flag',
  Food = 'food',
  Gift = 'gift',
  Glass = 'glass',
  Google = 'google',
  Heart = 'heart',
  Heartempty = 'heartempty',
  Home = 'home',
  IconBed = 'iconBed',
  Info = 'info',
  Key = 'key',
  Leaf = 'leaf',
  Load = 'load',
  Lock = 'lock',
  Longarrowdown = 'longarrowdown',
  Marker = 'marker',
  Minus = 'minus',
  Money = 'money',
  Music = 'music',
  Picture = 'picture',
  Plane = 'plane',
  Plus = 'plus',
  Pound = 'pound',
  Refresh = 'refresh',
  Road = 'road',
  Share = 'share',
  Shield = 'shield',
  Shoppingcart = 'shoppingcart',
  Smile = 'smile',
  Star = 'star',
  Starempty = 'starempty',
  Suitcase = 'suitcase',
  Sun = 'sun',
  Tag = 'tag',
  Thumbsupalt = 'thumbsupalt',
  Ticket = 'ticket',
  Time = 'time',
  Tint = 'tint',
  Travel = 'travel',
  Traveller = 'traveller',
  Trophy = 'trophy',
  Twitter = 'twitter',
  Unlockalt = 'unlockalt',
  Usd = 'usd',
  User = 'user',
  Warningsign = 'warningsign',
  Zoom = 'zoom',
}

export enum ImageFormat {
  Landscape = 'landscape',
  Portrait = 'portrait',
}

export interface LandingPageChildPage {
  __typename?: 'LandingPageChildPage';
  active?: Maybe<Scalars['Boolean']['output']>;
  content?: Maybe<Maybe<LandingPageContentBlocks>[]>;
  countdownVariant?: Maybe<CountdownVariant>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  highlights?: Maybe<LandingPageHighlights>;
  mainImage?: Maybe<LandingPageMainImage>;
  metadata?: Maybe<LandingPageMetadata>;
  nonUrgencyColour?: Maybe<Scalars['String']['output']>;
  queryLimits?: Maybe<LandingPageQueryLimits>;
  sectionTitles?: Maybe<LandingPageSectionTitles>;
  slug?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<LandingPageTags>;
  title?: Maybe<Scalars['String']['output']>;
  urgencyColour?: Maybe<Scalars['String']['output']>;
}

export interface LandingPageCollectionPanel {
  __typename?: 'LandingPageCollectionPanel';
  imageUrl?: Maybe<Scalars['String']['output']>;
  redirectLink?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
}

export interface LandingPageContentBlocks {
  __typename?: 'LandingPageContentBlocks';
  cta?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  imgAltDes?: Maybe<Scalars['String']['output']>;
  imgAltMob?: Maybe<Scalars['String']['output']>;
  imgUrlDes?: Maybe<Scalars['String']['output']>;
  imgUrlMob?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
}

export interface LandingPageHighlights {
  __typename?: 'LandingPageHighlights';
  cta?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  iconName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
}

export interface LandingPageMainImage {
  __typename?: 'LandingPageMainImage';
  cta?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  imgAltDes?: Maybe<Scalars['String']['output']>;
  imgAltMob?: Maybe<Scalars['String']['output']>;
  imgUrlDes?: Maybe<Scalars['String']['output']>;
  imgUrlMob?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
}

export interface LandingPageMetadata {
  __typename?: 'LandingPageMetadata';
  description?: Maybe<Scalars['String']['output']>;
  keywords?: Maybe<Maybe<Scalars['String']['output']>[]>;
  title?: Maybe<Scalars['String']['output']>;
}

export interface LandingPageParentPage {
  __typename?: 'LandingPageParentPage';
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
}

export interface LandingPageQueryLimits {
  __typename?: 'LandingPageQueryLimits';
  recommendationDes?: Maybe<Scalars['Int']['output']>;
  recommendationMob?: Maybe<Scalars['Int']['output']>;
}

export interface LandingPageResponse {
  __typename?: 'LandingPageResponse';
  active?: Maybe<Scalars['Boolean']['output']>;
  childPages?: Maybe<Maybe<LandingPageChildPage>[]>;
  collectionPanels?: Maybe<Maybe<LandingPageCollectionPanel>[]>;
  content?: Maybe<Maybe<LandingPageContentBlocks>[]>;
  countdownVariant?: Maybe<CountdownVariant>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  highlights?: Maybe<Maybe<LandingPageHighlights>[]>;
  mainImage?: Maybe<LandingPageMainImage>;
  metadata?: Maybe<LandingPageMetadata>;
  nonUrgencyColour?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<LandingPageParentPage>;
  queryLimits?: Maybe<LandingPageQueryLimits>;
  sectionTitles?: Maybe<LandingPageSectionTitles>;
  slug?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<LandingPageTags>;
  title?: Maybe<Scalars['String']['output']>;
  urgencyColour?: Maybe<Scalars['String']['output']>;
}

export interface LandingPageSectionTitles {
  __typename?: 'LandingPageSectionTitles';
  content?: Maybe<Scalars['String']['output']>;
  highlights?: Maybe<Scalars['String']['output']>;
  panels?: Maybe<Scalars['String']['output']>;
  recommendations?: Maybe<Scalars['String']['output']>;
}

export interface LandingPageTags {
  __typename?: 'LandingPageTags';
  page?: Maybe<Maybe<Scalars['String']['output']>[]>;
  search?: Maybe<Maybe<Scalars['String']['output']>[]>;
}

export interface LiveChat {
  __typename?: 'LiveChat';
  /** The live chat script */
  script?: Maybe<Scalars['String']['output']>;
}

export interface Location {
  __typename?: 'Location';
  /** City */
  city?: Maybe<LocationEntry>;
  /** City District */
  cityDistrict?: Maybe<LocationEntry>;
  /** Continent */
  continent?: Maybe<LocationEntry>;
  /** Country */
  country?: Maybe<LocationEntry>;
  /** Division */
  division?: Maybe<LocationEntry>;
  /** Latitude */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Longitude */
  longitude?: Maybe<Scalars['Float']['output']>;
}

export interface LocationEntry {
  __typename?: 'LocationEntry';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
}

export enum MailingPreferenceOptions {
  All = 'ALL',
  Unsubscribe = 'UNSUBSCRIBE',
  WeeklySummary = 'WEEKLY_SUMMARY',
}

export enum MapProvider {
  Google = 'google',
  Woosmap = 'woosmap',
}

export interface Mutation {
  __typename?: 'Mutation';
  addFavorite: FavoriteResponse;
  addReminder: ReminderResponse;
  cancelBooking: BookingCancellationResponse;
  removeFavorite: FavoriteResponse;
  removeReminder: ReminderResponse;
  sendConfirmationEmail?: Maybe<ConfirmationEmailResponse>;
  sendResetPasswordEmail?: Maybe<ResetPasswordResponse>;
  updateSubscriptionPreferences: UpdateSubscriptionPreferencesResponse;
}

export interface MutationAddFavoriteArgs {
  saleId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}

export interface MutationAddReminderArgs {
  saleId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}

export interface MutationCancelBookingArgs {
  bookingId: Scalars['String']['input'];
  rebooking?: InputMaybe<Scalars['Boolean']['input']>;
  refundMethod?: InputMaybe<Scalars['String']['input']>;
}

export interface MutationRemoveFavoriteArgs {
  saleId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}

export interface MutationRemoveReminderArgs {
  saleId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}

export interface MutationSendConfirmationEmailArgs {
  bookingId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}

export interface MutationSendResetPasswordEmailArgs {
  email: Scalars['String']['input'];
}

export interface MutationUpdateSubscriptionPreferencesArgs {
  breakPeriod?: InputMaybe<Scalars['Int']['input']>;
  browserToken?: InputMaybe<Scalars['String']['input']>;
  consentHistory?: InputMaybe<ConsentHistoryEntry>;
  mailingPreference?: InputMaybe<MailingPreferenceOptions>;
  receiveHandPickedOffers?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['String']['input'];
  webPushPreference?: InputMaybe<WebPushPreferenceOptions>;
}

export interface NightFacet {
  __typename?: 'NightFacet';
  /** The amount */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Pre-formatted amount for display */
  amountForDisplay?: Maybe<Scalars['String']['output']>;
  /** The number of nights */
  nights?: Maybe<Scalars['Int']['output']>;
}

export interface Occupancy {
  __typename?: 'Occupancy';
  /** Maximum number of adults */
  adults: Scalars['Int']['output'];
  /** Maximum number of children */
  children: Scalars['Int']['output'];
  /** Maximum number of infants */
  infants: Scalars['Int']['output'];
}

export interface Offer {
  __typename?: 'Offer';
  /** The availability for the offer */
  availability?: Maybe<Availability>;
  /** The availability for the offer */
  availabilityScalar?: Maybe<Scalars['AvailabilityScalar']['output']>;
  /** The calendar for the offer */
  calendar?: Maybe<Calendar>;
  /**
   * Summary of calendar selection for specific days
   * @deprecated Rebookings are using Tracy
   */
  calendarSelectionSummary?: Maybe<CalendarSelectionSummary>;
  /** Cancellation Policy Info */
  cancellationInfo?: Maybe<CancellationInfo>;
  /** Description of the offer */
  description?: Maybe<Scalars['String']['output']>;
  /** The details of the offer */
  details?: Maybe<OfferDetails>;
  /** ID of the offer */
  id: Scalars['String']['output'];
  /** Information about what is included in the offer */
  inclusions?: Maybe<OfferInclusions>;
  /** The flag informing if its the default offer */
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  /** The offer prices */
  prices?: Maybe<Prices>;
  /** RateCode of the offer */
  rateCode?: Maybe<Scalars['String']['output']>;
  /** The offer total price */
  receipt?: Maybe<Receipt>;
  /** Fee disclaimer for the offer */
  resortFeeDescription?: Maybe<Scalars['String']['output']>;
  /** The details of the room */
  room?: Maybe<OfferRoom>;
  /** Title of the offer */
  title?: Maybe<Scalars['String']['output']>;
}

export interface OfferAvailabilityArgs {
  checkInFirstDate?: InputMaybe<Scalars['String']['input']>;
  checkInLastDate?: InputMaybe<Scalars['String']['input']>;
  flightPreferences?: InputMaybe<FlightPreferencesInput>;
  operationName?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['Int']['input']>;
  rooms: Scalars['Int']['input'];
  signedBookingId?: InputMaybe<Scalars['String']['input']>;
}

export interface OfferAvailabilityScalarArgs {
  checkInFirstDate?: InputMaybe<Scalars['String']['input']>;
  checkInLastDate?: InputMaybe<Scalars['String']['input']>;
  flightPreferences?: InputMaybe<FlightPreferencesInput>;
  operationName?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['Int']['input']>;
  rooms: Scalars['Int']['input'];
  signedBookingId?: InputMaybe<Scalars['String']['input']>;
}

export interface OfferCalendarArgs {
  rooms: Scalars['Int']['input'];
}

export interface OfferCalendarSelectionSummaryArgs {
  checkin?: InputMaybe<Scalars['String']['input']>;
  checkout?: InputMaybe<Scalars['String']['input']>;
  rebookedReservationId?: InputMaybe<Scalars['String']['input']>;
  rooms?: InputMaybe<Scalars['Int']['input']>;
}

export interface OfferReceiptArgs {
  date: Scalars['String']['input'];
  departureAirports: Scalars['String']['input'][];
  groups: GroupsInput[];
  nights: Scalars['Int']['input'];
  people: PersonInput[];
  tracyOfferId: Scalars['String']['input'];
}

export interface OfferDetails {
  __typename?: 'OfferDetails';
  /** The offer image */
  image?: Maybe<Scalars['String']['output']>;
  /** The offer location */
  location?: Maybe<Scalars['String']['output']>;
  /** The long description of the offer */
  longDescription?: Maybe<Scalars['String']['output']>;
}

export interface OfferFacet {
  __typename?: 'OfferFacet';
  /** Discount */
  discount?: Maybe<Scalars['Int']['output']>;
  /** Offer id */
  id?: Maybe<Scalars['String']['output']>;
  /** Lead rate */
  leadRate?: Maybe<Rate>;
  /** Max units available */
  maxAvailability?: Maybe<Scalars['Int']['output']>;
  /** Minimum nights */
  minimumNights?: Maybe<Scalars['Int']['output']>;
  /** Rack rate */
  rackRate?: Maybe<Rate>;
  /** Whether the discount percentage should be shown or not */
  showDiscount?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the original price should be shown or not */
  showRackRate?: Maybe<Scalars['Boolean']['output']>;
}

export interface OfferInclusions {
  __typename?: 'OfferInclusions';
  /** The descriptions on which basis the total Inclusions value is calculated, e.g. based on 2 people for 2 nights */
  totalInclusionsDescription?: Maybe<Scalars['String']['output']>;
  /** The monetary value for all the extras that are included with the offer, formatted for the territory currency and locale */
  totalInclusionsForDisplay?: Maybe<Scalars['String']['output']>;
}

export interface OfferRoom {
  __typename?: 'OfferRoom';
  /** The text information about the room */
  info?: Maybe<OfferRoomInfo>;
  /** The limits for the room */
  limit?: Maybe<OfferRoomLimit>;
  /** Photos of room */
  photos?: Maybe<Maybe<Photo>[]>;
  /** The room based On Description */
  roomBasedOn?: Maybe<Scalars['String']['output']>;
  /** The room description */
  roomDescription?: Maybe<Scalars['String']['output']>;
  /** The room type singular */
  roomType?: Maybe<Scalars['String']['output']>;
  /** The room type plural */
  roomTypePlural?: Maybe<Scalars['String']['output']>;
}

export interface OfferRoomInfo {
  __typename?: 'OfferRoomInfo';
  /** The offer room child policy */
  childPolicy?: Maybe<Scalars['String']['output']>;
  /** The offer room single policy */
  singlePolicy?: Maybe<Scalars['String']['output']>;
}

export interface OfferRoomLimit {
  __typename?: 'OfferRoomLimit';
  /** The limit of adults in the room */
  maxAdults?: Maybe<Scalars['Int']['output']>;
  /**
   * The limit of all persons in the room
   * @deprecated Field coming from deprecated ARI endpoint. Use offer > prices > maxAvailability instead.
   */
  maxAvailable?: Maybe<Scalars['Int']['output']>;
  /** Max age limit allowed for a child in a room */
  maxChildAge?: Maybe<Scalars['Int']['output']>;
  /** The limit of children in the room */
  maxChildren?: Maybe<Scalars['Int']['output']>;
  /** The limit of dependants in the room */
  maxDependants?: Maybe<Scalars['Int']['output']>;
  /** Max age limit allowed for an infant in a room */
  maxInfantAge?: Maybe<Scalars['Int']['output']>;
  /** The limit of infants in the room */
  maxInfants?: Maybe<Scalars['Int']['output']>;
  /** Min age limit allowed for a child in a room */
  minChildAge?: Maybe<Scalars['Int']['output']>;
  /** Min age limit allowed for an infant in a room */
  minInfantAge?: Maybe<Scalars['Int']['output']>;
}

export interface PackagePriceBasis {
  __typename?: 'PackagePriceBasis';
  /** The number of adults the package price is based on */
  adults?: Maybe<Scalars['Int']['output']>;
  /** The number of children the package price is based on */
  children?: Maybe<Scalars['Int']['output']>;
  /** The number of infants the package price is based on */
  infants?: Maybe<Scalars['Int']['output']>;
  /** Whether the package price is per night */
  isPerNight?: Maybe<Scalars['Boolean']['output']>;
  /** The package price mode (Per Person or Per Unit) */
  mode?: Maybe<Scalars['String']['output']>;
}

export enum PackageType {
  Hotel = 'Hotel',
  IncludingFlights = 'IncludingFlights',
}

export interface PackageTypeFacet {
  __typename?: 'PackageTypeFacet';
  /** Airport */
  airport?: Maybe<AirportInfo>;
  /** Discount */
  discount?: Maybe<Scalars['Int']['output']>;
  /** Lead rate */
  leadRate?: Maybe<Rate>;
  /** Minimum nights */
  minimumNights?: Maybe<Scalars['Int']['output']>;
  /** Rack rate */
  rackRate?: Maybe<Rate>;
  /** Whether the discount percentage should be shown or not */
  showDiscount?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the original price should be shown or not */
  showRackRate?: Maybe<Scalars['Boolean']['output']>;
  /** Type of package */
  type?: Maybe<PackageType>;
}

export enum PageName {
  BookingConfirmation = 'bookingConfirmation',
  Collections = 'collections',
  ConfirmPayment = 'confirmPayment',
  CurrentSales = 'currentSales',
  Offers = 'offers',
  SearchResults = 'searchResults',
}

export interface PersonInput {
  /** Age of person */
  age?: InputMaybe<Scalars['Int']['input']>;
  /** Birth date of person */
  birthDate?: InputMaybe<Scalars['String']['input']>;
}

export interface Photo {
  __typename?: 'Photo';
  /** Caption */
  caption?: Maybe<Scalars['String']['output']>;
  /** Max Height */
  maxHeight?: Maybe<Scalars['Int']['output']>;
  /** Max Width */
  maxWidth?: Maybe<Scalars['Int']['output']>;
  /** URL */
  url?: Maybe<Scalars['String']['output']>;
}

export interface Price {
  __typename?: 'Price';
  /** Pre-formatted price to be displayed verbatim in the display layer */
  forDisplay?: Maybe<Scalars['String']['output']>;
  /** Unit price */
  unit?: Maybe<Scalars['Float']['output']>;
  /** Unit price per-person */
  unitPerPerson?: Maybe<Scalars['Float']['output']>;
}

export interface PriceBreakdown {
  __typename?: 'PriceBreakdown';
  /** Breakdown items */
  items?: Maybe<Maybe<PriceBreakdownItem>[]>;
  /** Total price of all items */
  total: Price;
}

export interface PriceBreakdownItem {
  __typename?: 'PriceBreakdownItem';
  /** Item concept */
  concept: Scalars['String']['output'];
  /** Is item Tax or Fee */
  isTaxOrFee?: Maybe<Scalars['Boolean']['output']>;
  /** Item price */
  price: Price;
}

export interface Prices {
  __typename?: 'Prices';
  /** Availability information when it is a date search */
  availability?: Maybe<AvailabilityPrices>;
  /** Currency */
  currency?: Maybe<Currency>;
  /** Price to be paid initially when deposit booking is made */
  depositFromPrice?: Maybe<Price>;
  /** Discount in percentage */
  discount?: Maybe<Scalars['Int']['output']>;
  /** Localised tooltip label for discount value */
  discountTooltip?: Maybe<Scalars['String']['output']>;
  /** The discounted rate offered by secret escapes */
  leadRate?: Maybe<Price>;
  /** Localised label for discounted price */
  leadRateLabel?: Maybe<Scalars['String']['output']>;
  /** Localised tooltip label for discounted price */
  leadRateTooltip?: Maybe<Scalars['String']['output']>;
  /** Localised label for the discounted price unit */
  leadRateUnitLabel?: Maybe<Scalars['String']['output']>;
  /** Max units available */
  maxAvailability?: Maybe<Scalars['Int']['output']>;
  /** Max number of adults that can occupy same room */
  maxNumberOfAdults?: Maybe<Scalars['Int']['output']>;
  /** Number of nights spent in hotel, without any nights spent in plane etc. Refers to one of offers, arbitrary chosen as best one for sale display purposes */
  numberOfHotelNights?: Maybe<Scalars['Int']['output']>;
  /** Price of what is exposed to user. Eg per room, per person */
  pricingModelForDisplay?: Maybe<Scalars['String']['output']>;
  /** Display rules related to prices */
  pricingRules?: Maybe<PricingRules>;
  /** The hotel rate, without any discounts */
  rackRate?: Maybe<Price>;
  /** Sale price with flights (H+) */
  withFlights?: Maybe<WithFlightsPrice>;
}

export interface PricingRules {
  __typename?: 'PricingRules';
  /** Whether the discount percentage should be shown or not */
  showDiscount?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the discounted prices should be shown or not */
  showPrices?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the original price should be shown or not */
  showRackRate?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the urgent discount price should be shown or not */
  showUrgentDiscount?: Maybe<Scalars['Boolean']['output']>;
}

export enum ProductLineType {
  BedbankJuniper = 'BEDBANK_JUNIPER',
  Catalogue = 'CATALOGUE',
  Flash = 'FLASH',
  HotelOnly = 'HOTEL_ONLY',
  HotelPlus = 'HOTEL_PLUS',
  IhpStatic = 'IHP_STATIC',
  ThirdPartyPackage = 'THIRD_PARTY_PACKAGE',
}

export interface PromotionalContentType {
  __typename?: 'PromotionalContentType';
  enumType: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface Query {
  __typename?: 'Query';
  advertisements?: Maybe<Maybe<Advertisement>[]>;
  booking?: Maybe<Booking>;
  bookings?: Maybe<Maybe<Booking>[]>;
  bookingsCount?: Maybe<BookingsCount>;
  checkIfUserRequiresPassword?: Maybe<CheckIfUserRequiresPasswordResponse>;
  collection?: Maybe<Collection>;
  collectionPanels?: Maybe<Maybe<CollectionPanel>[]>;
  collections?: Maybe<Maybe<Collection>[]>;
  creditSummary?: Maybe<CreditSummary>;
  editorsPickSale?: Maybe<Sale>;
  favorites?: Maybe<Maybe<Scalars['String']['output']>[]>;
  featureFlags?: Maybe<Maybe<FeatureFlags>[]>;
  fetchAdHeaderConfigScript?: Maybe<AdHeaderConfigScriptResponse>;
  fetchStaticMapUrl?: Maybe<StaticMapResponse>;
  frequentlyAskedQuestions?: Maybe<Maybe<FrequentlyAskedSection>[]>;
  gladlyIdentity?: Maybe<GladlyIdentity>;
  homepagePromotionalSections?: Maybe<Maybe<HomepagePromotionalSection>[]>;
  landingPage?: Maybe<LandingPageResponse>;
  liveChat?: Maybe<LiveChat>;
  locations?: Maybe<Maybe<Scalars['String']['output']>[]>;
  recentlyViewedSales?: Maybe<Maybe<Sale>[]>;
  recommendations?: Maybe<Maybe<Sale>[]>;
  reminders?: Maybe<Maybe<Scalars['String']['output']>[]>;
  sale?: Maybe<Sale>;
  saleByUrl?: Maybe<Sale>;
  saleSearch?: Maybe<SearchResults>;
  sales?: Maybe<Maybe<Sale>[]>;
  subscriptionPreferences?: Maybe<SubscriptionPreferencesResponse>;
  upcomingSales?: Maybe<UpcomingSalesResults>;
  userEngagement?: Maybe<UserEngagement>;
  webpushTracking?: Maybe<TrackWebPushInteractionResponse>;
}

export interface QueryAdvertisementsArgs {
  affiliate: Scalars['String']['input'];
  mobile?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<PageName>;
}

export interface QueryBookingArgs {
  bookingId: Scalars['String']['input'];
}

export interface QueryBookingsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}

export interface QueryBookingsCountArgs {
  userId?: InputMaybe<Scalars['String']['input']>;
}

export interface QueryCheckIfUserRequiresPasswordArgs {
  email: Scalars['String']['input'];
}

export interface QueryCollectionArgs {
  affiliate: Scalars['String']['input'];
  urlSlug: Scalars['String']['input'];
}

export interface QueryCollectionPanelsArgs {
  imageFormat?: InputMaybe<ImageFormat>;
  territory?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CollectionType>;
}

export interface QueryCollectionsArgs {
  affiliate: Scalars['String']['input'];
}

export interface QueryEditorsPickSaleArgs {
  affiliate?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  isWhiteLabel?: InputMaybe<Scalars['Boolean']['input']>;
  territory?: InputMaybe<Scalars['String']['input']>;
}

export interface QueryFavoritesArgs {
  userId: Scalars['String']['input'];
}

export interface QueryFeatureFlagsArgs {
  affiliate?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['Boolean']['input']>;
  system: System;
  territory?: InputMaybe<Scalars['String']['input']>;
  urlParams?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
}

export interface QueryFetchAdHeaderConfigScriptArgs {
  affiliate: Scalars['String']['input'];
  defaultDepartureAirport?: InputMaybe<Scalars['String']['input']>;
  departureAirportList?: InputMaybe<InputMaybe<Scalars['String']['input']>[]>;
  destinationCity?: InputMaybe<Scalars['String']['input']>;
  destinationCountry?: InputMaybe<Scalars['String']['input']>;
  destinationRegion?: InputMaybe<Scalars['String']['input']>;
  destinationType?: InputMaybe<Scalars['String']['input']>;
  holidayType?: InputMaybe<Scalars['String']['input']>;
  mobile: Scalars['Boolean']['input'];
  page: AdHeaderConfigScriptPageName;
  saleId?: InputMaybe<Scalars['String']['input']>;
  saleType?: InputMaybe<Scalars['String']['input']>;
}

export interface QueryFetchStaticMapUrlArgs {
  config?: InputMaybe<StaticMapConfig>;
  isMobile: Scalars['Boolean']['input'];
  latitude: Scalars['String']['input'];
  longitude: Scalars['String']['input'];
  provider?: InputMaybe<MapProvider>;
}

export interface QueryFrequentlyAskedQuestionsArgs {
  affiliate?: InputMaybe<Scalars['String']['input']>;
}

export interface QueryHomepagePromotionalSectionsArgs {
  affiliate: Scalars['String']['input'];
}

export interface QueryLandingPageArgs {
  affiliate: Scalars['String']['input'];
  slug: Scalars['String']['input'];
}

export interface QueryLiveChatArgs {
  affiliate?: InputMaybe<Scalars['String']['input']>;
}

export interface QueryLocationsArgs {
  additionalJuniperQuery?: InputMaybe<Scalars['Boolean']['input']>;
  locationQuery: Scalars['String']['input'];
  returnOnlyJuniperSales?: InputMaybe<Scalars['Boolean']['input']>;
  territory: Scalars['String']['input'];
}

export interface QueryRecentlyViewedSalesArgs {
  affiliate?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  includeJuniper?: InputMaybe<Scalars['Boolean']['input']>;
  isWhiteLabel?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  territory?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
}

export interface QueryRecommendationsArgs {
  affiliate?: InputMaybe<Scalars['String']['input']>;
  attachEditorsPick?: InputMaybe<Scalars['Boolean']['input']>;
  checkin?: InputMaybe<Scalars['String']['input']>;
  checkout?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  isWhiteLabel?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  saleIds?: InputMaybe<InputMaybe<Scalars['String']['input']>[]>;
  source?: InputMaybe<RecommendationSource>;
  territory: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
}

export interface QueryRemindersArgs {
  userId: Scalars['String']['input'];
}

export interface QuerySaleArgs {
  affiliate?: InputMaybe<Scalars['String']['input']>;
  checkin?: InputMaybe<Scalars['String']['input']>;
  checkout?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  flexibleDates?: InputMaybe<Scalars['Boolean']['input']>;
  isMobile?: InputMaybe<Scalars['Boolean']['input']>;
  previewMode?: InputMaybe<Scalars['Boolean']['input']>;
  provider?: InputMaybe<MapProvider>;
  saleId: Scalars['String']['input'];
  territory?: InputMaybe<Scalars['String']['input']>;
}

export interface QuerySaleByUrlArgs {
  affiliate?: InputMaybe<Scalars['String']['input']>;
  isMobile?: InputMaybe<Scalars['Boolean']['input']>;
  previewMode?: InputMaybe<Scalars['Boolean']['input']>;
  provider?: InputMaybe<MapProvider>;
  territory?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
}

export interface QuerySaleSearchArgs {
  additionalJuniperQuery?: InputMaybe<Scalars['Boolean']['input']>;
  checkin?: InputMaybe<Scalars['String']['input']>;
  checkout?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<InputMaybe<Scalars['String']['input']>[]>;
  currency?: InputMaybe<Scalars['String']['input']>;
  departureAirports?: InputMaybe<InputMaybe<Scalars['String']['input']>[]>;
  facilities?: InputMaybe<Scalars['String']['input'][]>;
  flexibleDates?: InputMaybe<Scalars['Boolean']['input']>;
  includeCrossSellData?: InputMaybe<Scalars['Boolean']['input']>;
  includeFacets?: InputMaybe<Scalars['Boolean']['input']>;
  isWhiteLabel?: InputMaybe<Scalars['Boolean']['input']>;
  maxPrice?: InputMaybe<Scalars['Int']['input']>;
  minPrice?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  removeEditorsPick?: InputMaybe<Scalars['Boolean']['input']>;
  returnOnlyJuniperSales?: InputMaybe<Scalars['Boolean']['input']>;
  saleIds?: InputMaybe<InputMaybe<Scalars['String']['input']>[]>;
  searchSource?: InputMaybe<SearchSource>;
  showTaxesAndFeesPrice?: InputMaybe<Scalars['Boolean']['input']>;
  skipFallbackToFuzzy?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<SortOrder>;
  startedSince?: InputMaybe<Scalars['String']['input']>;
  territory?: InputMaybe<Scalars['String']['input']>;
  travelTypes?: InputMaybe<InputMaybe<Scalars['String']['input']>[]>;
  travellersSelection?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  withFlights?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface QuerySalesArgs {
  affiliate?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  isWhiteLabel?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  territory?: InputMaybe<Scalars['String']['input']>;
}

export interface QuerySubscriptionPreferencesArgs {
  userId?: InputMaybe<Scalars['String']['input']>;
}

export interface QueryUpcomingSalesArgs {
  affiliate?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  isWhiteLabel?: InputMaybe<Scalars['Boolean']['input']>;
  territory?: InputMaybe<Scalars['String']['input']>;
}

export interface QueryUserEngagementArgs {
  territory: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}

export interface QueryWebpushTrackingArgs {
  campaignId?: InputMaybe<Scalars['String']['input']>;
  messageId: Scalars['String']['input'];
  templateId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
}

export interface Rate {
  __typename?: 'Rate';
  /** The amount */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Pre-formatted amount for display */
  amountForDisplay?: Maybe<Scalars['String']['output']>;
}

export interface Receipt {
  __typename?: 'Receipt';
  /** The amount */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Pre-formatted amount for display */
  amountForDisplay?: Maybe<Scalars['String']['output']>;
  /** Flag whether it is refundable */
  isRefundable?: Maybe<Scalars['Boolean']['output']>;
  /** The max availability */
  maxAvailability?: Maybe<Scalars['Int']['output']>;
  /** The number of nights */
  nights?: Maybe<Scalars['Int']['output']>;
  /** The amount including taxes and fees */
  totalAmount?: Maybe<Scalars['Float']['output']>;
  /** Pre-formatted amount for display including taxes and fees */
  totalAmountForDisplay?: Maybe<Scalars['String']['output']>;
}

export enum RecommendationSource {
  SearchRecommendations = 'search_recommendations',
  UserRecommendations = 'user_recommendations',
}

export interface RefinementFacetsEntry {
  __typename?: 'RefinementFacetsEntry';
  /** Refinement facet entry name */
  name?: Maybe<Scalars['String']['output']>;
  /** List of elements */
  value?: Maybe<Maybe<Scalars['String']['output']>[]>;
}

export interface ReminderResponse {
  __typename?: 'ReminderResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
}

export interface ResetPasswordResponse {
  __typename?: 'ResetPasswordResponse';
  message?: Maybe<Scalars['String']['output']>;
}

export interface Reviews {
  __typename?: 'Reviews';
  /** background Color */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Get review Badge */
  badges?: Maybe<Maybe<ReviewsBadge>[]>;
  /** Hotel ID of the review. It's typically generated by saleforce. */
  hotelId?: Maybe<Scalars['String']['output']>;
  /** Third-party provider ID (As of now TrustYou) */
  providerId?: Maybe<Scalars['String']['output']>;
  /** Score */
  score?: Maybe<Scalars['Float']['output']>;
  /** Score Description */
  scoreDescription?: Maybe<Scalars['String']['output']>;
  /** text Color */
  textColor?: Maybe<Scalars['String']['output']>;
  /** Total Count for reviews */
  totalReviewsCount?: Maybe<Scalars['Int']['output']>;
}

export interface ReviewsBadge {
  __typename?: 'ReviewsBadge';
  /** Gets the Id for category */
  categoryId?: Maybe<Scalars['String']['output']>;
  /** Badge subtext */
  subtext?: Maybe<Scalars['String']['output']>;
  /** Badge text */
  text?: Maybe<Scalars['String']['output']>;
}

export interface Sale {
  __typename?: 'Sale';
  alternativeLinks?: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** Attributes */
  attributes?: Maybe<SaleAttributes>;
  /** The Badges of the Sale */
  badges?: Maybe<Maybe<Badge>[]>;
  /** Urgency information */
  bookingStats?: Maybe<BookingStats>;
  /** Calendar for a sale */
  calendar?: Maybe<SaleCalendar>;
  /** Calendar facets for a sale */
  calendarFacets?: Maybe<CalendarFacets>;
  consumerInformation: ConsumerInformation[];
  /** Dates information */
  dates?: Maybe<Dates>;
  /** default offer id of the sale */
  defaultOfferId?: Maybe<Scalars['String']['output']>;
  /** Editorial content, descriptions of sale and hotel */
  editorial?: Maybe<SaleEditorial>;
  /** Facilities for the sale */
  facilities?: Maybe<Maybe<FacilitiesGroup>[]>;
  /**
   * Flights
   * @deprecated Deprecated by receipt in DEV-82152
   */
  flights?: Maybe<FlightPrices>;
  /** hotelCode for the sale */
  hotelCodes?: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** hotelName for the sale */
  hotelName?: Maybe<Scalars['String']['output']>;
  /** ID of the sale */
  id: Scalars['String']['output'];
  /** Sale labels */
  labels?: Maybe<Maybe<SaleLabel>[]>;
  /** Urls related */
  links?: Maybe<SaleLinks>;
  /** Location */
  location?: Maybe<Location>;
  /** Maintenance */
  maintenance?: Maybe<SaleMaintenance>;
  /** A specific offer for a sale */
  offer?: Maybe<Offer>;
  /** The offers for the sale */
  offers?: Maybe<Maybe<Offer>[]>;
  /** Photos, first one will be main photo */
  photos?: Maybe<Maybe<Photo>[]>;
  /** Sale prices */
  prices?: Maybe<Prices>;
  /** Product line type */
  productLine?: Maybe<ProductLineType>;
  provider?: Maybe<Scalars['String']['output']>;
  /** metadata for the reviews */
  reviews?: Maybe<Reviews>;
  staticMapUrl?: Maybe<Scalars['String']['output']>;
  /** Tags */
  tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
  tracyOfferId?: Maybe<Scalars['String']['output']>;
  /** Transport related information */
  travel?: Maybe<SaleTravel>;
  /** Sale type */
  type: SaleType;
}

export interface SaleBadgesArgs {
  channel?: InputMaybe<BadgeChannel>;
  isWhiteLabel?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfPromoBadges?: InputMaybe<Scalars['Int']['input']>;
}

export interface SaleCalendarArgs {
  departureAirports: Scalars['String']['input'][];
  groups?: InputMaybe<GroupsInput[]>;
  nights: Scalars['Int']['input'][];
  packageGroups: Scalars['String']['input'][];
  people?: InputMaybe<PersonInput[]>;
  rooms?: InputMaybe<Scalars['Int']['input']>;
}

export interface SaleCalendarFacetsArgs {
  departureAirports: Scalars['String']['input'][];
  groups?: InputMaybe<GroupsInput[]>;
  nights: Scalars['Int']['input'][];
  packageGroups: Scalars['String']['input'][];
  packageType: PackageType;
  people?: InputMaybe<PersonInput[]>;
  rooms?: InputMaybe<Scalars['Int']['input']>;
}

export interface SaleFlightsArgs {
  departureAirportCode?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  flightsEnabled: Scalars['Boolean']['input'];
  offerId?: InputMaybe<Scalars['String']['input']>;
  saleId?: InputMaybe<Scalars['String']['input']>;
  territory?: InputMaybe<Scalars['String']['input']>;
}

export interface SaleOfferArgs {
  offerId: Scalars['String']['input'];
}

export interface SalePhotosArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
}

export interface SaleReviewsArgs {
  territory?: InputMaybe<Scalars['String']['input']>;
}

export interface SaleTagsArgs {
  keys?: InputMaybe<InputMaybe<Scalars['String']['input']>[]>;
}

export interface SaleAttributes {
  __typename?: 'SaleAttributes';
  /** Whether the sale is active */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Is it connected sale */
  isConnected?: Maybe<Scalars['Boolean']['output']>;
  /** Whether it is current or upcoming sale */
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  /** Is deposit */
  isDepositSale?: Maybe<Scalars['Boolean']['output']>;
  /** Dynamic Package */
  isDynamicPackage?: Maybe<Scalars['Boolean']['output']>;
  /** Editor's pick */
  isEditorsPick?: Maybe<Scalars['Boolean']['output']>;
  /** Exclusive sale */
  isExclusive?: Maybe<Scalars['Boolean']['output']>;
  /** Mysterious */
  isMysterious?: Maybe<Scalars['Boolean']['output']>;
  /** Can the sale be displayed to the user as refundable */
  isRefundable?: Maybe<Scalars['Boolean']['output']>;
  /** Smart Stay */
  isSmartStay?: Maybe<Scalars['Boolean']['output']>;
  /** Does the sale have an end date the user should be aware of */
  isTimeLimited?: Maybe<Scalars['Boolean']['output']>;
  /** Is zero deposit */
  isZeroDeposit?: Maybe<Scalars['Boolean']['output']>;
}

export interface SaleCalendar {
  __typename?: 'SaleCalendar';
  /** The calendar */
  checkInDates: AvailableCheckInDate[];
  /** The first available check in date */
  firstAvailableCheckInDate?: Maybe<Scalars['String']['output']>;
  /** The last available check in date */
  lastAvailableCheckInDate?: Maybe<Scalars['String']['output']>;
  /** The last available check out date */
  lastAvailableCheckOutDate?: Maybe<Scalars['String']['output']>;
  /** The basis of the package price */
  packagePriceBasis?: Maybe<PackagePriceBasis>;
}

export interface SaleEditorial {
  __typename?: 'SaleEditorial';
  /** Deal includes */
  dealIncludes?: Maybe<Scalars['String']['output']>;
  /** User friendly, one sentence destination usually including hotel name, city, region name */
  destinationName?: Maybe<Scalars['String']['output']>;
  /** Hotel details */
  hotelDetails?: Maybe<Scalars['String']['output']>;
  /** Location */
  location?: Maybe<Scalars['String']['output']>;
  /** Main paragraph */
  mainParagraph?: Maybe<Scalars['String']['output']>;
  /** Short, one sentence information about cool things about the venue */
  reasonToLove?: Maybe<Scalars['String']['output']>;
  /** Where user is going to sleep eg room, tent */
  roomDescription?: Maybe<Scalars['String']['output']>;
  /** How hotel is described at other web pages */
  secondOpinion?: Maybe<Scalars['String']['output']>;
  /** summary */
  summary?: Maybe<Scalars['String']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Travel details */
  travelDetails?: Maybe<Scalars['String']['output']>;
  /** We Like */
  weLike?: Maybe<Scalars['String']['output']>;
}

export interface SaleLabel {
  __typename?: 'SaleLabel';
  /** HexCode */
  hexCode: Scalars['String']['output'];
  /** Icon code */
  iconCode: IconName;
  /** Label Key */
  labelKey?: Maybe<Scalars['String']['output']>;
  /** Summary */
  summary?: Maybe<Scalars['String']['output']>;
}

export interface SaleLinks {
  __typename?: 'SaleLinks';
  /** Link to price comparsion */
  priceComparison?: Maybe<Scalars['String']['output']>;
  /** Relative link to sale details page */
  sale?: Maybe<Scalars['String']['output']>;
  /** Link to tripadvisors page where hotel of the sale is reviewed */
  tripAdvisor?: Maybe<Scalars['String']['output']>;
}

export interface SaleMaintenance {
  __typename?: 'SaleMaintenance';
  /** Whether the sale is on maintenance */
  isOutageOngoing?: Maybe<Scalars['Boolean']['output']>;
  /** Maintenance end date */
  outageEndDate?: Maybe<Scalars['String']['output']>;
}

export interface SaleTravel {
  __typename?: 'SaleTravel';
  /** can the flight be added while booking is made */
  hasFlightsAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** is flight already included in price */
  hasFlightsIncluded?: Maybe<Scalars['Boolean']['output']>;
  /** The closest airport to the destination */
  preferredAirportCode?: Maybe<Scalars['String']['output']>;
  /** Type of travel, eg flight, train */
  travelType?: Maybe<Scalars['String']['output']>;
}

/**
 * Hotel type - basic  offer contains of room only. Stock is maintained by SE or fetched from external provider
 * Package - basic offer contains of room and flight. Hotel and flight configuration is done by SE
 * IHP - basic offer contains of room and flight.  Hotel and flight configuration is done by external provider
 * WRD - Web redirect sales - offer contains of either rooms or rooms + flights. User is redirected to partner site in order to see do the booking
 */
export enum SaleType {
  Hotel = 'hotel',
  Ihp = 'ihp',
  Package = 'package',
  Wrd = 'wrd',
}

export interface SearchResults {
  __typename?: 'SearchResults';
  /** Number of bed-bank (Juniper) hotels in the result set. Only populated when includeCrossSellData is requested. */
  bedBankCount?: Maybe<Scalars['Int']['output']>;
  /** Cheapest package for the destination, used by the packages cross-sell banner. Only populated when includeCrossSellData is requested. */
  cheapestPackage?: Maybe<CheapestPackage>;
  /** Number of directly contracted hotels in the result set. Only populated when includeCrossSellData is requested. */
  directContractedCount?: Maybe<Scalars['Int']['output']>;
  /** List of names of facilities groups, also known as honeycomb facts group, eg Leisure activities, Food and drink */
  displayFacets?: Maybe<DisplayFacets>;
  /** Number of packages available for the destination. Only populated when includeCrossSellData is requested. */
  packageResultCount?: Maybe<Scalars['Int']['output']>;
  /** Search query */
  query?: Maybe<Scalars['String']['output']>;
  /** Refinement facets list */
  refinementFacets?: Maybe<Maybe<RefinementFacetsEntry>[]>;
  /** Count of results */
  resultCount?: Maybe<Scalars['Int']['output']>;
  /** List of sales */
  sales?: Maybe<Maybe<Sale>[]>;
  /** Spell checked suggestion */
  spellCheckedQuery?: Maybe<Scalars['Boolean']['output']>;
}

export interface SearchResultsSalesArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}

export enum SearchSource {
  Kingfisher = 'kingfisher',
  V4 = 'v4',
}

export enum SortOrder {
  Discount = 'DISCOUNT',
  Newest = 'NEWEST',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  Relevance = 'RELEVANCE',
}

export interface StaticMapConfig {
  height?: InputMaybe<Scalars['Int']['input']>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  mapType?: InputMaybe<Scalars['String']['input']>;
  scale?: InputMaybe<StaticMapDeviceConfig>;
  width?: InputMaybe<Scalars['Int']['input']>;
  zoom?: InputMaybe<StaticMapDeviceConfig>;
}

export interface StaticMapDeviceConfig {
  desktop?: InputMaybe<Scalars['Int']['input']>;
  mobile?: InputMaybe<Scalars['Int']['input']>;
}

export interface StaticMapResponse {
  __typename?: 'StaticMapResponse';
  url: Scalars['String']['output'];
}

export enum StayType {
  Fixed = 'FIXED',
  Flexible = 'FLEXIBLE',
}

export interface SubscriptionPreferencesPriorToBreak {
  __typename?: 'SubscriptionPreferencesPriorToBreak';
  reactivateFromBreakDate?: Maybe<Scalars['String']['output']>;
  receiveHandPickedOffers?: Maybe<Scalars['Boolean']['output']>;
  receiveSalesReminders?: Maybe<Scalars['Boolean']['output']>;
  receiveWeeklyOffers?: Maybe<Scalars['Boolean']['output']>;
  webPushPreference?: Maybe<WebPushPreferenceOptions>;
}

export interface SubscriptionPreferencesResponse {
  __typename?: 'SubscriptionPreferencesResponse';
  blockSubscriptionUpdates: Scalars['Boolean']['output'];
  break: SubscriptionPreferencesPriorToBreak;
  profile: SubscriptionProfilePreferences;
}

export interface SubscriptionProfilePreferences {
  __typename?: 'SubscriptionProfilePreferences';
  lastUpdated?: Maybe<Scalars['String']['output']>;
  receiveHandPickedOffers: Scalars['Boolean']['output'];
  receiveSalesReminders: Scalars['Boolean']['output'];
  receiveWeeklyOffers: Scalars['Boolean']['output'];
  webPushPreference: WebPushPreferenceOptions;
}

export enum System {
  Bullfinch = 'BULLFINCH',
  Cauldron = 'CAULDRON',
  Sparrow = 'SPARROW',
  Tracy = 'TRACY',
  Vision = 'VISION',
}

export interface TrackWebPushInteractionResponse {
  __typename?: 'TrackWebPushInteractionResponse';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
}

export interface UpcomingSalesResults {
  __typename?: 'UpcomingSalesResults';
  /** Count of results */
  resultCount?: Maybe<Scalars['Int']['output']>;
  /** List of sales */
  sales?: Maybe<Maybe<Sale>[]>;
}

export interface UpcomingSalesResultsSalesArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}

export interface UpdateSubscriptionPreferencesResponse {
  __typename?: 'UpdateSubscriptionPreferencesResponse';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
}

export interface UserEngagement {
  __typename?: 'UserEngagement';
  score?: Maybe<Scalars['Int']['output']>;
}

export enum WebPushPreferenceOptions {
  Off = 'OFF',
  On = 'ON',
}

export interface WithFlightsPrice {
  __typename?: 'WithFlightsPrice';
  /** Departure airport code for price */
  departureAirportCode?: Maybe<Scalars['String']['output']>;
  /** Departure airport name for price */
  departureAirportName?: Maybe<Scalars['String']['output']>;
  /** duration for price */
  duration?: Maybe<Scalars['Int']['output']>;
  /** Price for an offer */
  forDisplay?: Maybe<Scalars['String']['output']>;
}

export type OffersQueryVariables = Exact<{
  saleId: Scalars['String']['input'];
  affiliate?: InputMaybe<Scalars['String']['input']>;
  territory?: InputMaybe<Scalars['String']['input']>;
}>;

export interface OffersQuery {
  __typename?: 'Query';
  sale?:
    | {
        __typename?: 'Sale';
        id: string;
        offers?:
          | (
              | {
                  __typename?: 'Offer';
                  id: string;
                  title?: string | null | undefined;
                  description?: string | null | undefined;
                  cancellationInfo?:
                    | {
                        __typename?: 'CancellationInfo';
                        isRefundable: boolean;
                        description?: string | null | undefined;
                        descriptionWithFlights?: string | null | undefined;
                        descriptionWarning?: string | null | undefined;
                        descriptionWarningWithFlights?: string | null | undefined;
                        numberOfDays?: number | null | undefined;
                      }
                    | null
                    | undefined;
                  details?:
                    | { __typename?: 'OfferDetails'; longDescription?: string | null | undefined }
                    | null
                    | undefined;
                  room?:
                    | {
                        __typename?: 'OfferRoom';
                        roomType?: string | null | undefined;
                        roomTypePlural?: string | null | undefined;
                        info?:
                          | {
                              __typename?: 'OfferRoomInfo';
                              childPolicy?: string | null | undefined;
                              singlePolicy?: string | null | undefined;
                            }
                          | null
                          | undefined;
                        limit?:
                          | {
                              __typename?: 'OfferRoomLimit';
                              maxAdults?: number | null | undefined;
                              maxInfants?: number | null | undefined;
                              maxChildren?: number | null | undefined;
                              maxDependants?: number | null | undefined;
                              maxChildAge?: number | null | undefined;
                              minChildAge?: number | null | undefined;
                              maxInfantAge?: number | null | undefined;
                              minInfantAge?: number | null | undefined;
                            }
                          | null
                          | undefined;
                        photos?:
                          | (
                              | {
                                  __typename?: 'Photo';
                                  url?: string | null | undefined;
                                  caption?: string | null | undefined;
                                  maxHeight?: number | null | undefined;
                                  maxWidth?: number | null | undefined;
                                }
                              | null
                              | undefined
                            )[]
                          | null
                          | undefined;
                      }
                    | null
                    | undefined;
                }
              | null
              | undefined
            )[]
          | null
          | undefined;
      }
    | null
    | undefined;
}

export type CalendarQueryVariables = Exact<{
  saleId: Scalars['String']['input'];
  affiliate?: InputMaybe<Scalars['String']['input']>;
  territory?: InputMaybe<Scalars['String']['input']>;
  packageGroups: Scalars['String']['input'][] | Scalars['String']['input'];
  people: PersonInput[] | PersonInput;
  groups: GroupsInput[] | GroupsInput;
  nights: Scalars['Int']['input'][] | Scalars['Int']['input'];
  departureAirports: Scalars['String']['input'][] | Scalars['String']['input'];
}>;

export interface CalendarQuery {
  __typename?: 'Query';
  sale?:
    | {
        __typename?: 'Sale';
        calendar?:
          | {
              __typename?: 'SaleCalendar';
              firstAvailableCheckInDate?: string | null | undefined;
              lastAvailableCheckInDate?: string | null | undefined;
              lastAvailableCheckOutDate?: string | null | undefined;
              packagePriceBasis?:
                | {
                    __typename?: 'PackagePriceBasis';
                    adults?: number | null | undefined;
                    children?: number | null | undefined;
                    infants?: number | null | undefined;
                    isPerNight?: boolean | null | undefined;
                    mode?: string | null | undefined;
                  }
                | null
                | undefined;
              checkInDates: {
                __typename?: 'AvailableCheckInDate';
                date: string;
                amount?: number | null | undefined;
                amountForDisplay?: string | null | undefined;
                isRefundable?: boolean | null | undefined;
                checkOutDates: {
                  __typename?: 'AvailableCheckOutDate';
                  date: string;
                  nights?: number | null | undefined;
                  amount?: number | null | undefined;
                  amountForDisplay?: string | null | undefined;
                }[];
              }[];
            }
          | null
          | undefined;
      }
    | null
    | undefined;
}

export type FacetsQueryVariables = Exact<{
  saleId: Scalars['String']['input'];
  affiliate?: InputMaybe<Scalars['String']['input']>;
  territory?: InputMaybe<Scalars['String']['input']>;
  packageGroups: Scalars['String']['input'][] | Scalars['String']['input'];
  people: PersonInput[] | PersonInput;
  groups: GroupsInput[] | GroupsInput;
  nights: Scalars['Int']['input'][] | Scalars['Int']['input'];
  departureAirports: Scalars['String']['input'][] | Scalars['String']['input'];
  packageType: PackageType;
}>;

export interface FacetsQuery {
  __typename?: 'Query';
  sale?:
    | {
        __typename?: 'Sale';
        id: string;
        calendarFacets?:
          | {
              __typename?: 'CalendarFacets';
              packagePriceBasis?:
                | {
                    __typename?: 'PackagePriceBasis';
                    adults?: number | null | undefined;
                    children?: number | null | undefined;
                    infants?: number | null | undefined;
                    isPerNight?: boolean | null | undefined;
                    mode?: string | null | undefined;
                  }
                | null
                | undefined;
              airports?:
                | {
                    __typename?: 'AirportFacet';
                    code?: string | null | undefined;
                    name?: string | null | undefined;
                    cityName?: string | null | undefined;
                    amount?: number | null | undefined;
                    amountForDisplay?: string | null | undefined;
                  }[]
                | null
                | undefined;
              nights?:
                | {
                    __typename?: 'NightFacet';
                    nights?: number | null | undefined;
                    amount?: number | null | undefined;
                    amountForDisplay?: string | null | undefined;
                  }[]
                | null
                | undefined;
              offers?:
                | {
                    __typename?: 'OfferFacet';
                    id?: string | null | undefined;
                    discount?: number | null | undefined;
                    minimumNights?: number | null | undefined;
                    maxAvailability?: number | null | undefined;
                    showDiscount?: boolean | null | undefined;
                    showRackRate?: boolean | null | undefined;
                    leadRate?:
                      | {
                          __typename?: 'Rate';
                          amount?: number | null | undefined;
                          amountForDisplay?: string | null | undefined;
                        }
                      | null
                      | undefined;
                    rackRate?:
                      | {
                          __typename?: 'Rate';
                          amount?: number | null | undefined;
                          amountForDisplay?: string | null | undefined;
                        }
                      | null
                      | undefined;
                  }[]
                | null
                | undefined;
              packageTypes?:
                | {
                    __typename?: 'PackageTypeFacet';
                    type?: PackageType | null | undefined;
                    discount?: number | null | undefined;
                    minimumNights?: number | null | undefined;
                    showDiscount?: boolean | null | undefined;
                    showRackRate?: boolean | null | undefined;
                    leadRate?:
                      | {
                          __typename?: 'Rate';
                          amount?: number | null | undefined;
                          amountForDisplay?: string | null | undefined;
                        }
                      | null
                      | undefined;
                    rackRate?:
                      | {
                          __typename?: 'Rate';
                          amount?: number | null | undefined;
                          amountForDisplay?: string | null | undefined;
                        }
                      | null
                      | undefined;
                    airport?:
                      | {
                          __typename?: 'AirportInfo';
                          code?: string | null | undefined;
                          name?: string | null | undefined;
                          cityName?: string | null | undefined;
                        }
                      | null
                      | undefined;
                  }[]
                | null
                | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
}

export type ReceiptsQueryVariables = Exact<{
  saleId: Scalars['String']['input'];
  tracyOfferId: Scalars['String']['input'];
  territory?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['String']['input'];
  nights: Scalars['Int']['input'];
  people: PersonInput[] | PersonInput;
  groups: GroupsInput[] | GroupsInput;
  departureAirports: Scalars['String']['input'][] | Scalars['String']['input'];
}>;

export interface ReceiptsQuery {
  __typename?: 'Query';
  sale?:
    | {
        __typename?: 'Sale';
        id: string;
        offers?:
          | (
              | {
                  __typename?: 'Offer';
                  id: string;
                  receipt?:
                    | {
                        __typename?: 'Receipt';
                        amount?: number | null | undefined;
                        amountForDisplay?: string | null | undefined;
                        totalAmount?: number | null | undefined;
                        totalAmountForDisplay?: string | null | undefined;
                        nights?: number | null | undefined;
                        isRefundable?: boolean | null | undefined;
                        maxAvailability?: number | null | undefined;
                      }
                    | null
                    | undefined;
                }
              | null
              | undefined
            )[]
          | null
          | undefined;
      }
    | null
    | undefined;
}

export type AddFavoriteMutationVariables = Exact<{
  saleId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;

export interface AddFavoriteMutation {
  __typename?: 'Mutation';
  addFavorite: {
    __typename?: 'FavoriteResponse';
    success: boolean;
    message?: string | null | undefined;
  };
}

export type RemoveFavoriteMutationVariables = Exact<{
  saleId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;

export interface RemoveFavoriteMutation {
  __typename?: 'Mutation';
  removeFavorite: {
    __typename?: 'FavoriteResponse';
    success: boolean;
    message?: string | null | undefined;
  };
}

export type SaleForMobileAppQueryVariables = Exact<{
  saleId: Scalars['String']['input'];
  affiliate?: InputMaybe<Scalars['String']['input']>;
  territory?: InputMaybe<Scalars['String']['input']>;
}>;

export interface SaleForMobileAppQuery {
  __typename?: 'Query';
  sale?:
    | {
        __typename?: 'Sale';
        tracyOfferId?: string | null | undefined;
        hotelName?: string | null | undefined;
        tags?: (string | null | undefined)[] | null | undefined;
        maintenance?:
          | {
              __typename?: 'SaleMaintenance';
              isOutageOngoing?: boolean | null | undefined;
              outageEndDate?: string | null | undefined;
            }
          | null
          | undefined;
        travel?:
          | { __typename?: 'SaleTravel'; hasFlightsAvailable?: boolean | null | undefined }
          | null
          | undefined;
        prices?:
          | {
              __typename?: 'Prices';
              discountTooltip?: string | null | undefined;
              numberOfHotelNights?: number | null | undefined;
              currency?:
                | { __typename?: 'Currency'; currencyCode?: string | null | undefined }
                | null
                | undefined;
              leadRate?:
                | {
                    __typename?: 'Price';
                    forDisplay?: string | null | undefined;
                    unit?: number | null | undefined;
                  }
                | null
                | undefined;
              rackRate?:
                | { __typename?: 'Price'; forDisplay?: string | null | undefined }
                | null
                | undefined;
              withFlights?:
                | {
                    __typename?: 'WithFlightsPrice';
                    forDisplay?: string | null | undefined;
                    departureAirportCode?: string | null | undefined;
                    departureAirportName?: string | null | undefined;
                    duration?: number | null | undefined;
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
}

export type FavouritesQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;

export interface FavouritesQuery {
  __typename?: 'Query';
  favorites?: (string | null | undefined)[] | null | undefined;
}

export type SaleQueryVariables = Exact<{
  saleId: Scalars['String']['input'];
  affiliate?: InputMaybe<Scalars['String']['input']>;
  territory?: InputMaybe<Scalars['String']['input']>;
  showPricingAndAvailability: Scalars['Boolean']['input'];
  provider: MapProvider;
  reviewsEnabled: Scalars['Boolean']['input'];
  previewMode?: InputMaybe<Scalars['Boolean']['input']>;
  isMobile?: InputMaybe<Scalars['Boolean']['input']>;
  isWhiteLabel?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export interface SaleQuery {
  __typename?: 'Query';
  sale?:
    | {
        __typename?: 'Sale';
        staticMapUrl?: string | null | undefined;
        id: string;
        tracyOfferId?: string | null | undefined;
        hotelName?: string | null | undefined;
        type: SaleType;
        tags?: (string | null | undefined)[] | null | undefined;
        dates?:
          | {
              __typename?: 'Dates';
              start?: string | null | undefined;
              end?: string | null | undefined;
            }
          | null
          | undefined;
        maintenance?:
          | {
              __typename?: 'SaleMaintenance';
              isOutageOngoing?: boolean | null | undefined;
              outageEndDate?: string | null | undefined;
            }
          | null
          | undefined;
        photos?:
          | (
              | {
                  __typename?: 'Photo';
                  url?: string | null | undefined;
                  caption?: string | null | undefined;
                  maxHeight?: number | null | undefined;
                  maxWidth?: number | null | undefined;
                }
              | null
              | undefined
            )[]
          | null
          | undefined;
        facilities?:
          | (
              | {
                  __typename?: 'FacilitiesGroup';
                  key: string;
                  name?: string | null | undefined;
                  facts?:
                    | (
                        | {
                            __typename?: 'FacilitiesFact';
                            key: string;
                            name?: string | null | undefined;
                            exists?: boolean | null | undefined;
                            level?: string | null | undefined;
                            number?: number | null | undefined;
                            attributes?:
                              | (
                                  | {
                                      __typename?: 'FacilitiesAttribute';
                                      key: string;
                                      name?: string | null | undefined;
                                      value?:
                                        | (
                                            | {
                                                __typename?: 'FacilitiesAttributeValue';
                                                start?: string | null | undefined;
                                                end?: string | null | undefined;
                                                value?: string | null | undefined;
                                              }
                                            | null
                                            | undefined
                                          )[]
                                        | null
                                        | undefined;
                                    }
                                  | null
                                  | undefined
                                )[]
                              | null
                              | undefined;
                          }
                        | null
                        | undefined
                      )[]
                    | null
                    | undefined;
                }
              | null
              | undefined
            )[]
          | null
          | undefined;
        prices?:
          | {
              __typename?: 'Prices';
              discount?: number | null | undefined;
              discountTooltip?: string | null | undefined;
              leadRateTooltip?: string | null | undefined;
              numberOfHotelNights?: number | null | undefined;
              currency?:
                | { __typename?: 'Currency'; currencyCode?: string | null | undefined }
                | null
                | undefined;
              leadRate?:
                | {
                    __typename?: 'Price';
                    forDisplay?: string | null | undefined;
                    unit?: number | null | undefined;
                  }
                | null
                | undefined;
              rackRate?:
                | { __typename?: 'Price'; forDisplay?: string | null | undefined }
                | null
                | undefined;
              pricingRules?:
                | {
                    __typename?: 'PricingRules';
                    showDiscount?: boolean | null | undefined;
                    showPrices?: boolean | null | undefined;
                    showRackRate?: boolean | null | undefined;
                    showUrgentDiscount?: boolean | null | undefined;
                  }
                | null
                | undefined;
              withFlights?:
                | {
                    __typename?: 'WithFlightsPrice';
                    forDisplay?: string | null | undefined;
                    departureAirportCode?: string | null | undefined;
                    departureAirportName?: string | null | undefined;
                    duration?: number | null | undefined;
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
        attributes?:
          | { __typename?: 'SaleAttributes'; isTimeLimited?: boolean | null | undefined }
          | null
          | undefined;
        links?: { __typename?: 'SaleLinks'; sale?: string | null | undefined } | null | undefined;
        travel?:
          | { __typename?: 'SaleTravel'; hasFlightsAvailable?: boolean | null | undefined }
          | null
          | undefined;
        location?:
          | {
              __typename?: 'Location';
              latitude?: number | null | undefined;
              longitude?: number | null | undefined;
              city?:
                | {
                    __typename?: 'LocationEntry';
                    name?: string | null | undefined;
                    id?: number | null | undefined;
                  }
                | null
                | undefined;
              cityDistrict?:
                | {
                    __typename?: 'LocationEntry';
                    name?: string | null | undefined;
                    id?: number | null | undefined;
                  }
                | null
                | undefined;
              country?:
                | {
                    __typename?: 'LocationEntry';
                    name?: string | null | undefined;
                    id?: number | null | undefined;
                  }
                | null
                | undefined;
              continent?:
                | {
                    __typename?: 'LocationEntry';
                    name?: string | null | undefined;
                    id?: number | null | undefined;
                  }
                | null
                | undefined;
              division?:
                | {
                    __typename?: 'LocationEntry';
                    name?: string | null | undefined;
                    id?: number | null | undefined;
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
        editorial?:
          | {
              __typename?: 'SaleEditorial';
              title?: string | null | undefined;
              destinationName?: string | null | undefined;
              weLike?: string | null | undefined;
              mainParagraph?: string | null | undefined;
              hotelDetails?: string | null | undefined;
              summary?: string | null | undefined;
              location?: string | null | undefined;
            }
          | null
          | undefined;
        badges?:
          | (
              | {
                  __typename?: 'Badge';
                  title?: string | null | undefined;
                  iconName?: string | null | undefined;
                  priority: number;
                  type: BadgeType;
                  backgroundColor?:
                    | { __typename?: 'BadgeColorScheme'; light: string }
                    | null
                    | undefined;
                  fontColor?: { __typename?: 'BadgeColorScheme'; light: string } | null | undefined;
                  tooltip?:
                    | {
                        __typename?: 'BadgeTooltip';
                        title?: string | null | undefined;
                        description?: string | null | undefined;
                      }
                    | null
                    | undefined;
                }
              | null
              | undefined
            )[]
          | null
          | undefined;
        reviews?:
          | {
              __typename?: 'Reviews';
              hotelId?: string | null | undefined;
              score?: number | null | undefined;
              scoreDescription?: string | null | undefined;
              backgroundColor?: string | null | undefined;
              textColor?: string | null | undefined;
              totalReviewsCount?: number | null | undefined;
              badges?:
                | (
                    | {
                        __typename?: 'ReviewsBadge';
                        categoryId?: string | null | undefined;
                        text?: string | null | undefined;
                        subtext?: string | null | undefined;
                      }
                    | null
                    | undefined
                  )[]
                | null
                | undefined;
            }
          | null
          | undefined;
        consumerInformation: {
          __typename?: 'ConsumerInformation';
          type?: ProductLineType | null | undefined;
          text?: string | null | undefined;
        }[];
      }
    | null
    | undefined;
}

export const OffersDocument = gql`
  query Offers($saleId: String!, $affiliate: String, $territory: String) {
    sale(saleId: $saleId, affiliate: $affiliate, territory: $territory) {
      id
      offers {
        id
        title
        description
        cancellationInfo {
          isRefundable
          description
          descriptionWithFlights
          descriptionWarning
          descriptionWarningWithFlights
          numberOfDays
        }
        details {
          longDescription
        }
        room {
          info {
            childPolicy
            singlePolicy
          }
          limit {
            maxAdults
            maxInfants
            maxChildren
            maxDependants
            maxChildAge
            minChildAge
            maxInfantAge
            minInfantAge
          }
          roomType
          roomTypePlural
          photos {
            url
            caption
            maxHeight
            maxWidth
          }
        }
      }
    }
  }
`;

/**
 * __useOffersQuery__
 *
 * To run a query within a React component, call `useOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOffersQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      affiliate: // value for 'affiliate'
 *      territory: // value for 'territory'
 *   },
 * });
 */
export function useOffersQuery(
  baseOptions: Apollo.QueryHookOptions<OffersQuery, OffersQueryVariables> &
    ({ variables: OffersQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OffersQuery, OffersQueryVariables>(OffersDocument, options);
}
export function useOffersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OffersQuery, OffersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OffersQuery, OffersQueryVariables>(OffersDocument, options);
}
export function useOffersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<OffersQuery, OffersQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<OffersQuery, OffersQueryVariables>(OffersDocument, options);
}
export type OffersQueryHookResult = ReturnType<typeof useOffersQuery>;
export type OffersLazyQueryHookResult = ReturnType<typeof useOffersLazyQuery>;
export type OffersSuspenseQueryHookResult = ReturnType<typeof useOffersSuspenseQuery>;
export type OffersQueryResult = Apollo.QueryResult<OffersQuery, OffersQueryVariables>;
export const CalendarDocument = gql`
  query Calendar(
    $saleId: String!
    $affiliate: String
    $territory: String
    $packageGroups: [String!]!
    $people: [PersonInput!]!
    $groups: [GroupsInput!]!
    $nights: [Int!]!
    $departureAirports: [String!]!
  ) {
    sale(saleId: $saleId, affiliate: $affiliate, territory: $territory) {
      calendar(
        packageGroups: $packageGroups
        people: $people
        groups: $groups
        nights: $nights
        departureAirports: $departureAirports
      ) {
        packagePriceBasis {
          adults
          children
          infants
          isPerNight
          mode
        }
        firstAvailableCheckInDate
        lastAvailableCheckInDate
        lastAvailableCheckOutDate
        checkInDates {
          date
          amount
          amountForDisplay
          isRefundable
          checkOutDates {
            date
            nights
            amount
            amountForDisplay
          }
        }
      }
    }
  }
`;

/**
 * __useCalendarQuery__
 *
 * To run a query within a React component, call `useCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      affiliate: // value for 'affiliate'
 *      territory: // value for 'territory'
 *      packageGroups: // value for 'packageGroups'
 *      people: // value for 'people'
 *      groups: // value for 'groups'
 *      nights: // value for 'nights'
 *      departureAirports: // value for 'departureAirports'
 *   },
 * });
 */
export function useCalendarQuery(
  baseOptions: Apollo.QueryHookOptions<CalendarQuery, CalendarQueryVariables> &
    ({ variables: CalendarQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CalendarQuery, CalendarQueryVariables>(CalendarDocument, options);
}
export function useCalendarLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CalendarQuery, CalendarQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CalendarQuery, CalendarQueryVariables>(CalendarDocument, options);
}
export function useCalendarSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CalendarQuery, CalendarQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CalendarQuery, CalendarQueryVariables>(CalendarDocument, options);
}
export type CalendarQueryHookResult = ReturnType<typeof useCalendarQuery>;
export type CalendarLazyQueryHookResult = ReturnType<typeof useCalendarLazyQuery>;
export type CalendarSuspenseQueryHookResult = ReturnType<typeof useCalendarSuspenseQuery>;
export type CalendarQueryResult = Apollo.QueryResult<CalendarQuery, CalendarQueryVariables>;
export const FacetsDocument = gql`
  query Facets(
    $saleId: String!
    $affiliate: String
    $territory: String
    $packageGroups: [String!]!
    $people: [PersonInput!]!
    $groups: [GroupsInput!]!
    $nights: [Int!]!
    $departureAirports: [String!]!
    $packageType: PackageType!
  ) {
    sale(saleId: $saleId, affiliate: $affiliate, territory: $territory) {
      id
      calendarFacets(
        packageGroups: $packageGroups
        people: $people
        groups: $groups
        nights: $nights
        departureAirports: $departureAirports
        packageType: $packageType
      ) {
        packagePriceBasis {
          adults
          children
          infants
          isPerNight
          mode
        }
        airports {
          code
          name
          cityName
          amount
          amountForDisplay
        }
        nights {
          nights
          amount
          amountForDisplay
        }
        offers {
          id
          leadRate {
            amount
            amountForDisplay
          }
          rackRate {
            amount
            amountForDisplay
          }
          discount
          minimumNights
          maxAvailability
          showDiscount
          showRackRate
        }
        packageTypes {
          type
          leadRate {
            amount
            amountForDisplay
          }
          rackRate {
            amount
            amountForDisplay
          }
          discount
          minimumNights
          airport {
            code
            name
            cityName
          }
          showDiscount
          showRackRate
        }
      }
    }
  }
`;

/**
 * __useFacetsQuery__
 *
 * To run a query within a React component, call `useFacetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacetsQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      affiliate: // value for 'affiliate'
 *      territory: // value for 'territory'
 *      packageGroups: // value for 'packageGroups'
 *      people: // value for 'people'
 *      groups: // value for 'groups'
 *      nights: // value for 'nights'
 *      departureAirports: // value for 'departureAirports'
 *      packageType: // value for 'packageType'
 *   },
 * });
 */
export function useFacetsQuery(
  baseOptions: Apollo.QueryHookOptions<FacetsQuery, FacetsQueryVariables> &
    ({ variables: FacetsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FacetsQuery, FacetsQueryVariables>(FacetsDocument, options);
}
export function useFacetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FacetsQuery, FacetsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FacetsQuery, FacetsQueryVariables>(FacetsDocument, options);
}
export function useFacetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FacetsQuery, FacetsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FacetsQuery, FacetsQueryVariables>(FacetsDocument, options);
}
export type FacetsQueryHookResult = ReturnType<typeof useFacetsQuery>;
export type FacetsLazyQueryHookResult = ReturnType<typeof useFacetsLazyQuery>;
export type FacetsSuspenseQueryHookResult = ReturnType<typeof useFacetsSuspenseQuery>;
export type FacetsQueryResult = Apollo.QueryResult<FacetsQuery, FacetsQueryVariables>;
export const ReceiptsDocument = gql`
  query Receipts(
    $saleId: String!
    $tracyOfferId: String!
    $territory: String
    $date: String!
    $nights: Int!
    $people: [PersonInput!]!
    $groups: [GroupsInput!]!
    $departureAirports: [String!]!
  ) {
    sale(saleId: $saleId, territory: $territory) {
      id
      offers {
        id
        receipt(
          tracyOfferId: $tracyOfferId
          date: $date
          nights: $nights
          people: $people
          groups: $groups
          departureAirports: $departureAirports
        ) {
          amount
          amountForDisplay
          totalAmount
          totalAmountForDisplay
          nights
          isRefundable
          maxAvailability
        }
      }
    }
  }
`;

/**
 * __useReceiptsQuery__
 *
 * To run a query within a React component, call `useReceiptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReceiptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReceiptsQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      tracyOfferId: // value for 'tracyOfferId'
 *      territory: // value for 'territory'
 *      date: // value for 'date'
 *      nights: // value for 'nights'
 *      people: // value for 'people'
 *      groups: // value for 'groups'
 *      departureAirports: // value for 'departureAirports'
 *   },
 * });
 */
export function useReceiptsQuery(
  baseOptions: Apollo.QueryHookOptions<ReceiptsQuery, ReceiptsQueryVariables> &
    ({ variables: ReceiptsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReceiptsQuery, ReceiptsQueryVariables>(ReceiptsDocument, options);
}
export function useReceiptsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ReceiptsQuery, ReceiptsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ReceiptsQuery, ReceiptsQueryVariables>(ReceiptsDocument, options);
}
export function useReceiptsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReceiptsQuery, ReceiptsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ReceiptsQuery, ReceiptsQueryVariables>(ReceiptsDocument, options);
}
export type ReceiptsQueryHookResult = ReturnType<typeof useReceiptsQuery>;
export type ReceiptsLazyQueryHookResult = ReturnType<typeof useReceiptsLazyQuery>;
export type ReceiptsSuspenseQueryHookResult = ReturnType<typeof useReceiptsSuspenseQuery>;
export type ReceiptsQueryResult = Apollo.QueryResult<ReceiptsQuery, ReceiptsQueryVariables>;
export const AddFavoriteDocument = gql`
  mutation AddFavorite($saleId: String!, $userId: String!) {
    addFavorite(saleId: $saleId, userId: $userId) {
      success
      message
    }
  }
`;
export type AddFavoriteMutationFn = Apollo.MutationFunction<
  AddFavoriteMutation,
  AddFavoriteMutationVariables
>;

/**
 * __useAddFavoriteMutation__
 *
 * To run a mutation, you first call `useAddFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFavoriteMutation, { data, loading, error }] = useAddFavoriteMutation({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddFavoriteMutation(
  baseOptions?: Apollo.MutationHookOptions<AddFavoriteMutation, AddFavoriteMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddFavoriteMutation, AddFavoriteMutationVariables>(
    AddFavoriteDocument,
    options
  );
}
export type AddFavoriteMutationHookResult = ReturnType<typeof useAddFavoriteMutation>;
export type AddFavoriteMutationResult = Apollo.MutationResult<AddFavoriteMutation>;
export type AddFavoriteMutationOptions = Apollo.BaseMutationOptions<
  AddFavoriteMutation,
  AddFavoriteMutationVariables
>;
export const RemoveFavoriteDocument = gql`
  mutation RemoveFavorite($saleId: String!, $userId: String!) {
    removeFavorite(saleId: $saleId, userId: $userId) {
      success
      message
    }
  }
`;
export type RemoveFavoriteMutationFn = Apollo.MutationFunction<
  RemoveFavoriteMutation,
  RemoveFavoriteMutationVariables
>;

/**
 * __useRemoveFavoriteMutation__
 *
 * To run a mutation, you first call `useRemoveFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFavoriteMutation, { data, loading, error }] = useRemoveFavoriteMutation({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveFavoriteMutation(
  baseOptions?: Apollo.MutationHookOptions<RemoveFavoriteMutation, RemoveFavoriteMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveFavoriteMutation, RemoveFavoriteMutationVariables>(
    RemoveFavoriteDocument,
    options
  );
}
export type RemoveFavoriteMutationHookResult = ReturnType<typeof useRemoveFavoriteMutation>;
export type RemoveFavoriteMutationResult = Apollo.MutationResult<RemoveFavoriteMutation>;
export type RemoveFavoriteMutationOptions = Apollo.BaseMutationOptions<
  RemoveFavoriteMutation,
  RemoveFavoriteMutationVariables
>;
export const SaleForMobileAppDocument = gql`
  query SaleForMobileApp($saleId: String!, $affiliate: String, $territory: String) {
    sale(saleId: $saleId, affiliate: $affiliate, territory: $territory) {
      tracyOfferId
      hotelName
      tags
      maintenance {
        isOutageOngoing
        outageEndDate
      }
      travel {
        hasFlightsAvailable
      }
      prices {
        currency {
          currencyCode
        }
        discountTooltip
        leadRate {
          forDisplay
          unit
        }
        numberOfHotelNights
        rackRate {
          forDisplay
        }
        withFlights {
          forDisplay
          departureAirportCode
          departureAirportName
          duration
        }
      }
    }
  }
`;

/**
 * __useSaleForMobileAppQuery__
 *
 * To run a query within a React component, call `useSaleForMobileAppQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaleForMobileAppQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaleForMobileAppQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      affiliate: // value for 'affiliate'
 *      territory: // value for 'territory'
 *   },
 * });
 */
export function useSaleForMobileAppQuery(
  baseOptions: Apollo.QueryHookOptions<SaleForMobileAppQuery, SaleForMobileAppQueryVariables> &
    ({ variables: SaleForMobileAppQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SaleForMobileAppQuery, SaleForMobileAppQueryVariables>(
    SaleForMobileAppDocument,
    options
  );
}
export function useSaleForMobileAppLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SaleForMobileAppQuery, SaleForMobileAppQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SaleForMobileAppQuery, SaleForMobileAppQueryVariables>(
    SaleForMobileAppDocument,
    options
  );
}
export function useSaleForMobileAppSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SaleForMobileAppQuery, SaleForMobileAppQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SaleForMobileAppQuery, SaleForMobileAppQueryVariables>(
    SaleForMobileAppDocument,
    options
  );
}
export type SaleForMobileAppQueryHookResult = ReturnType<typeof useSaleForMobileAppQuery>;
export type SaleForMobileAppLazyQueryHookResult = ReturnType<typeof useSaleForMobileAppLazyQuery>;
export type SaleForMobileAppSuspenseQueryHookResult = ReturnType<
  typeof useSaleForMobileAppSuspenseQuery
>;
export type SaleForMobileAppQueryResult = Apollo.QueryResult<
  SaleForMobileAppQuery,
  SaleForMobileAppQueryVariables
>;
export const FavouritesDocument = gql`
  query Favourites($userId: String!) {
    favorites(userId: $userId)
  }
`;

/**
 * __useFavouritesQuery__
 *
 * To run a query within a React component, call `useFavouritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavouritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavouritesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFavouritesQuery(
  baseOptions: Apollo.QueryHookOptions<FavouritesQuery, FavouritesQueryVariables> &
    ({ variables: FavouritesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FavouritesQuery, FavouritesQueryVariables>(FavouritesDocument, options);
}
export function useFavouritesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FavouritesQuery, FavouritesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FavouritesQuery, FavouritesQueryVariables>(
    FavouritesDocument,
    options
  );
}
export function useFavouritesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FavouritesQuery, FavouritesQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FavouritesQuery, FavouritesQueryVariables>(
    FavouritesDocument,
    options
  );
}
export type FavouritesQueryHookResult = ReturnType<typeof useFavouritesQuery>;
export type FavouritesLazyQueryHookResult = ReturnType<typeof useFavouritesLazyQuery>;
export type FavouritesSuspenseQueryHookResult = ReturnType<typeof useFavouritesSuspenseQuery>;
export type FavouritesQueryResult = Apollo.QueryResult<FavouritesQuery, FavouritesQueryVariables>;
export const SaleDocument = gql`
  query Sale(
    $saleId: String!
    $affiliate: String
    $territory: String
    $showPricingAndAvailability: Boolean!
    $provider: MapProvider!
    $reviewsEnabled: Boolean!
    $previewMode: Boolean
    $isMobile: Boolean
    $isWhiteLabel: Boolean
  ) {
    sale(
      saleId: $saleId
      affiliate: $affiliate
      territory: $territory
      previewMode: $previewMode
      isMobile: $isMobile
      provider: $provider
    ) {
      staticMapUrl
      id
      tracyOfferId
      hotelName
      type
      dates {
        start
        end
      }
      tags
      maintenance @include(if: $showPricingAndAvailability) {
        isOutageOngoing
        outageEndDate
      }
      photos {
        url
        caption
        maxHeight
        maxWidth
      }
      facilities {
        key
        name
        facts {
          key
          name
          exists
          level
          number
          attributes {
            key
            name
            value {
              start
              end
              value
            }
          }
        }
      }
      prices {
        currency {
          currencyCode
        }
        discount
        discountTooltip
        leadRate {
          forDisplay
          unit
        }
        leadRateTooltip
        numberOfHotelNights
        rackRate {
          forDisplay
        }
        pricingRules {
          showDiscount
          showPrices
          showRackRate
          showUrgentDiscount
        }
        withFlights {
          forDisplay
          departureAirportCode
          departureAirportName
          duration
        }
      }
      attributes {
        isTimeLimited
      }
      links {
        sale
      }
      travel {
        hasFlightsAvailable
      }
      location {
        city {
          name
          id
        }
        cityDistrict {
          name
          id
        }
        country {
          name
          id
        }
        continent {
          name
          id
        }
        division {
          name
          id
        }
        latitude
        longitude
      }
      editorial {
        title
        destinationName
        weLike
        mainParagraph
        hotelDetails
        summary
        location
      }
      badges(channel: WEB, isWhiteLabel: $isWhiteLabel) {
        title
        iconName
        priority
        backgroundColor {
          light
        }
        fontColor {
          light
        }
        type
        tooltip {
          title
          description
        }
      }
      reviews(territory: $territory) @include(if: $reviewsEnabled) {
        hotelId
        score
        scoreDescription
        backgroundColor
        textColor
        totalReviewsCount
        badges {
          categoryId
          text
          subtext
        }
      }
      consumerInformation {
        type
        text
      }
    }
  }
`;

/**
 * __useSaleQuery__
 *
 * To run a query within a React component, call `useSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaleQuery({
 *   variables: {
 *      saleId: // value for 'saleId'
 *      affiliate: // value for 'affiliate'
 *      territory: // value for 'territory'
 *      showPricingAndAvailability: // value for 'showPricingAndAvailability'
 *      provider: // value for 'provider'
 *      reviewsEnabled: // value for 'reviewsEnabled'
 *      previewMode: // value for 'previewMode'
 *      isMobile: // value for 'isMobile'
 *      isWhiteLabel: // value for 'isWhiteLabel'
 *   },
 * });
 */
export function useSaleQuery(
  baseOptions: Apollo.QueryHookOptions<SaleQuery, SaleQueryVariables> &
    ({ variables: SaleQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SaleQuery, SaleQueryVariables>(SaleDocument, options);
}
export function useSaleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SaleQuery, SaleQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SaleQuery, SaleQueryVariables>(SaleDocument, options);
}
export function useSaleSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SaleQuery, SaleQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SaleQuery, SaleQueryVariables>(SaleDocument, options);
}
export type SaleQueryHookResult = ReturnType<typeof useSaleQuery>;
export type SaleLazyQueryHookResult = ReturnType<typeof useSaleLazyQuery>;
export type SaleSuspenseQueryHookResult = ReturnType<typeof useSaleSuspenseQuery>;
export type SaleQueryResult = Apollo.QueryResult<SaleQuery, SaleQueryVariables>;
